import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import {  Observable, of, throwError } from 'rxjs';
import { catchError, concatAll, delay, map, mergeMap, retryWhen, take, tap } from 'rxjs/operators';
import { AppSettings } from '../../app/appSettings';
import { SearchResult, Appointement, Doctor, Patient, Practice, Spec, Message, Med, Networker, TopSpec, Employee, newEmployee, News, DoctorDetail, PatientEvent} from '../content-provider/data-objects';
import moment from 'moment';
import { environment } from 'src/environments/environment';

@Injectable()
export class FacharztAPIService {
  

  DEBUG = AppSettings.DEBUG;
  TAG = "FacharztAPIService";
  instanceId: number = Math.random() * (99999 - 1) + 1;
  //public getErrorMessage = 'Das ist der letzte Versuch den Inhalt zu laden ohne Erfolg. Versuch abgebrochen.';

  //public DEFAULT_MAX_RETRIES = 3;

  /*
  public source = interval(1000);
  public retryFunction = this.source.pipe(
    map(val => {
      if (val > 5) {
        throw val;
      }
      return val;
    }),
    retryWhen(errors => 
      errors.pipe(
        tap(val => console.log('${val} sind zu viele Versuche'),
      ))
  ));
  */

  constructor(public http: HttpClient) { }



  retryFunction (errors:Observable<any>) {
    return errors;

    /*
    return errors.scan(function (errorCount: number, err) {
      if (err.status === 0 && err.statusText === "") {
        if (errorCount >= 3) {
          throw err;
        }
        return errorCount + 1;
      } else {
        throw err;
      }
    }, 0)
    .delay(1000);
    */

   

    //Todo update solution whats this?
    //return errors.status;

    /*
    console.log("retry val",errors);
    return errors.pipe(
      mergeMap((er: any) => {
        if (er.status === 0 && er.statusText === "") {
          if (errorCount >= 3) {
            return throwError(er);
          }
          return errorCount + 1;
        } else {
          return throwError(er);
        }
*/


        /*if (er.status === 504 || er.status === 503) {
          return of(er.status).pipe(delay(1000));
        }
        return throwError({message: er.statusText || 'Notification.Core.loginError'});
           })
    );
        */
   
    /*
    return errors.scan(function (errorCount: number, err) {
      if (err.status === 0 && err.statusText === "") {
        if (errorCount >= 3) {
          throw err;
        }
        return errorCount + 1;
      } else {
        throw err;
      }
    }, 0)
    .delay(1000);
  */
  }  

  login(
    user: string,
    password: string,
    isDoctor: boolean = false,
    isNetwork: boolean = false
  ): Observable<any> {
    let client = isDoctor ? "facharzt-sofort-pvs" : AppSettings.FS_API_client;
    let scope = isDoctor ? "" : "&`scope=patient_full_access`";
    let key = isDoctor ? "|{%nW?HWx0wv" : AppSettings.FS_API_KEY;
    if (isNetwork) {
      client = "facharzt-sofort-net";
      scope = "";
      key = "|{%nW?HW4net";
    }

    let formData = new FormData();
    formData.append("client_secret", key);
    formData.append("client_id", client);
    formData.append("username", user);
    formData.append("password", password);
    formData.append("grant_type", 'password');

    const url = `public/login`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  loginKC(
    data,
    isDoctor: boolean = false
  ): Observable<any> {
    let client = isDoctor ? "facharzt-sofort-pvs" : AppSettings.FS_API_client;
    let scope = isDoctor ? "" : "&`scope=patient_full_access`";
    let key = isDoctor ? "|{%nW?HWx0wv" : AppSettings.FS_API_KEY;
    /*const body: string =
      [
        `client_secret=${key}`,
        `client_id=${client}`,
        `username=${data.profile.preferred_username}`,
        `password=6YBChAd7lyaaFVLWvgrG`,
        `grant_type=password`,
        `kc_token=${data.token}`,
        `kc_name=${data.profile.given_name}`,
        `kc_surname=${data.profile.family_name}`,
      ].join("&") + scope;*/

    let formData = new FormData();
    formData.append("client_secret", key);
    formData.append("client_id", client); 
    formData.append("username", data.profile.preferred_username);
    formData.append("password", '6YBChAd7lyaaFVLWvgrG');
    formData.append("grant_type", 'password');
    formData.append("kc_token", data.token);
    formData.append("kc_name", data.profile.given_name);
    formData.append("kc_surname", data.profile.family_name);
    
    const url = `public/login`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }
//new register 
  register(
    anr: string,
    vorname: string,
    nachname: string,
    birthday: string,
    tel: string,
    email: string,
    password: string,
    agb: string,
    country: string
  ): Observable<any> {
    let formData = new FormData();
    formData.append("anr", anr);
    formData.append("vorname", vorname); 
    formData.append("nachname", nachname); 
    formData.append("ver", "0"); 
    formData.append("birthday", birthday); 
    formData.append("tel", tel); 
    formData.append("mob", tel);
    formData.append("street", "");
    formData.append("plz", "");
    formData.append("city", "");
    formData.append("email", email);
    formData.append("agb", agb);
    formData.append("country", country);
    formData.append("password", password);

    const url = `public/patient/registerweb`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    
    return this.http.post(queryUrl, formData, { headers: headers }).pipe(
      map((response: any) => {
        if(this.DEBUG)console.log('Full response:', response);
        if (response.status === 'success') {
          const hash = response.hash;
          if(this.DEBUG)console.log('Received Hash:', hash);
        } else {
          if(this.DEBUG)console.log('Error response:', response);
        }
        return response;
      })
    );
  }
  //End new Register 
  getDocRequests(docid: number) {
    //const body: string = [`docid=${docid}`].join("&");

    let formData = new FormData();
    formData.append("docid", docid.toString());
 
    const headers = new HttpHeaders().append("Accept","1.0");

    const url = `public/doctor/request`;

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getRequestTextById(docid: number) {
   // const body: string = [`docid=${docid}`].join("&");

   //Todo hier zu string umwandlen vorher
    let formData = new FormData();
    formData.append("docid", docid.toString());

    const headers = new HttpHeaders().append("Accept","1.0");

    const url = `public/doctor/getRequestTextById`;

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  registerDoctor(
    anr: string,
    vorname: string,
    nachname: string,
    title: string,
    street: string,
    plz: string,
    city: string,
    spec: string,
    praxis: string,
    pstreet: string,
    pplz: string,
    pcity: string,
    mobile: string,
    tel: string,
    email: string,
    password: string,
    agb: string
  ): Observable<any> {
    const body = {
      doctor: {
        anr: anr,
        title: title,
        last_name: nachname,
        first_name: vorname,
        email: email,
        password: password,
        tel: tel,
        zip: plz,
        city: city,
        address: street,
        specs: [spec],
      },
      practice: {
        name: praxis,
        email: email,
        tel: tel,
        address: pstreet,
        zip: pplz,
        city: pcity,
      },
      subdocs: [],
    };

    //Todo update wie übergeben

    const url = `public/doctor/register`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, body, {
        headers: headers,
      });
  }

  registerNetworker(id, password): Observable<any> {
    /*const body: string = [
      `id=${id}`,
      `password=${password}`,
    ].join("&");*/

    let formData = new FormData();
    formData.append("id", id);
    formData.append("password", password);
    
    const url = `public/network/registerNetworker`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  getNetworkerByHash(hash: string): Observable<any> {
    /*const body: string = [
      `hash=${hash}`,
    ].join("&");*/

    let formData = new FormData();
    formData.append("hash", hash);

    const url = `public/network/getNetworkerByHash`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  contact(subject: string, name: string, mail: string, telnumber: string, message: string): Observable<any> {
    /*const body: string = [
      `subject=${subject}`,
      `name=${name}`,
      `mail=${mail}`,
      `telnumber=${telnumber}`,
      `message=${message}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("subject", subject);
    formData.append("name", name);
    formData.append("mail", mail);
    formData.append("telnumber", telnumber);
    formData.append("message", message);

    const url = `public/doctor/contact`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  activate(hash: string, doc: boolean) {
    //const body: string = [`hash=${hash}`].join("&");
    let formData = new FormData();
    formData.append("hash", hash);

    const headers = new HttpHeaders().append("Accept","1.0");

    
    const url = `public/doctor/activate`;
    
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }
//new Register 
  activatePatient(verificationCode: string, hashedPatientId: string) {
    // Erstellen des FormData Objekts für den API-Aufruf
    let formData = new FormData();
    formData.append("code", verificationCode); // Übergabe des verificationCode
    formData.append("hashed_email", hashedPatientId); // Übergabe des gehashten Patient-IDs
  
    const headers = new HttpHeaders().append("Accept", "1.0");
  
    // API URL für den Aktivierungsaufruf
    const url = `${environment.baseApiUrl}public/patient/activate`;
  
    // Durchführung des HTTP-POST-Requests und Rückgabe der Antwort
    return this.http.post(url, formData, { headers: headers }).pipe(
      // Verarbeiten der Antwort
      map((response: any) => {
        if (response.success) {
          // Erfolg: Rückgabe der erfolgreichen Nachricht
          return {
            success: true,
            message: response.message
          };
        } else {
          // Fehler: Rückgabe der Fehlermeldung und failedAttempts
          return {
            success: false,
            message: response.message,
            failedAttempts: response.failedAttempts
          };
        }
      }),
      catchError((error) => {
        // Fehlerbehandlung: Rückgabe einer Fehlermeldung
        return throwError(() => new Error('Fehler bei der Aktivierung'));
      })
    );
  }
  
  
  newCode(hashedPatientId: string) {
    let formData = new FormData();
    formData.append("hashed_email", hashedPatientId); // Übergabe der gehashten Patient-ID
  
    const headers = new HttpHeaders().append("Accept", "1.0");
  
    const url = `${environment.baseApiUrl}public/patient/new`; // Angepasste URL für "new"
  
    return this.http.post(url, formData, { headers: headers });
  }
  //end new register 

  adminActivate(hash: string, doc: boolean) {
    //const body: string = [`hash=${hash}`].join("&");

    let formData = new FormData();
    formData.append("hash", hash);

    const headers = new HttpHeaders().append("Accept","1.0");

    let url = ``;
    if (doc) {
      url = `public/admin/activate/doctor`;
    } else {
      url = `public/admin/activate/patient`; // not implemented yet
    }

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  requestPasswordRecoveryLink(email: string, doc: boolean) {
    //const body: string = [`email=${email}`, `doctor=${doc}`].join("&");

    let formData = new FormData();
    formData.append("email", email);
    formData.append("doctor", doc.toString());

    const headers = new HttpHeaders().append("Accept","1.0");
    const url = `public/passwordrecoverylink`;
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  setNewPassword(hash: string, doc: boolean, pw: string) {
   /* const body: string = [`hash=${hash}`, `doctor=${doc}`, `pw=${pw}`].join(
      "&"
    );*/

    let formData = new FormData();
    formData.append("hash", hash);
    formData.append("doctor", doc.toString());
    formData.append("pw", pw);

    const headers = new HttpHeaders().append("Accept","1.0");
    const url = `public/setPasswordByHash`;
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  public getWidget(docId: number, time: number, color: string) {
    const queryUrl = "https://api.termed.de/v2/facharzt_widget.php?id=randomid&time=" + time + "&uid=" + docId + "&size=100%&color=" + color;

    if(this.DEBUG)console.log('url', queryUrl);
    return this.http.get(queryUrl);
  }

  public getAps(time: number, id: number, reason: number) {
    const queryUrl = environment.baseApiUrl + "getEvents.php?action=free&time=" + time + "&id=" + id + "&reason=" + reason;

    if(this.DEBUG)console.log('url', queryUrl);
    return this.http.get(queryUrl);
  }

  getUsedSpecs(): Observable<Array<Spec>> {
    const url = `public/specs/used`;
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.get(queryUrl).pipe(
      map((responseData: Response) => {
        return responseData;
      }),
      map((specs) => {
        const result: Array<Spec> = [];

        if (Array.isArray(specs)) {
          specs.forEach((spec) => {
            result.push(new Spec(spec));
          });
        }
        return result;
      }),
      //retryWhen(this.retryFunction)
    );
  }

  getTopSpecs(): Observable<Array<TopSpec>> {
    const url = `public/specs/most`;
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.get(queryUrl).pipe(
      map((responseData: Response) => {
        return responseData;
      }),
      map((topspec) => {
        const result: Array<TopSpec> = [];

        if (Array.isArray(topspec)) {
          topspec.forEach((topspec) => {
            result.push(new TopSpec(topspec));
          });
        }
        return result;
      }),

    );
  }


  getAllSpecs(): Observable<Array<Spec>> {
    const url = `public/specs/all`;
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.get(queryUrl).pipe(
      map((responseData: Response) => {
        return responseData;
      }),
      map((specs) => {
        const result: Array<Spec> = [];

        if (Array.isArray(specs)) {
          specs.forEach((spec) => {
            result.push(new Spec(spec));
          });
        }
        return result;
      }),
      //retryWhen(this.retryFunction)
    );
  }

  getDoctor(id: number): Observable<Doctor> {
    const url = `public/doc/`;
    const queryUrl = `${environment.baseApiUrl}${url}${id}`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return new Doctor(response);
      }),
      //retryWhen(this.retryFunction)
    );
  }


  //Todo Check Function
  getNetworker(accessToken: string): Observable<Networker> {
    const url = `private/network`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      })
      .pipe(
        map((response: Response) => {
          return new Networker(response.json);
        }),
        //retryWhen(this.retryFunction)
      );
  }

  getMed(pzn: number): Observable<Med> {
    const url = `public/med/`;
    const queryUrl = `${environment.baseApiUrl}${url}${pzn}`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return new Med(response);
      }),
      //retryWhen(this.retryFunction)
    );
  }

  findMed(query: string): Observable<Array<Med>> {
    const url = `public/search/med`;
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http.post(queryUrl, { value: query }).pipe(
      map((responseData: Response) => {
        return responseData;
      }),
      
      map((response) => {
        
        const result: Array<Med> = [];

        if (Array.isArray(response)) {
          response.forEach((med) => {
            result.push(new Med(med));
          });
        }
        
        return result;
      }),
      
      // map((response: Response) => {
      //   console.log(response.json);
      //   return new Med(response.json);
      // }),
      //retryWhen(this.retryFunction)
    );
  }

  getApp(appid: number): Observable<any> {
    const url = `public/app/`;
    const queryUrl = `${environment.baseApiUrl}${url}${appid}`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        // console.log(response.json);
        // return new Med(response.json);
        return response.json;
      }),
      //retryWhen(this.retryFunction)
    );
  }

  getReasonData(reasonId: number): Observable<any> {
    const url = `public/reason/`;
    const queryUrl = `${environment.baseApiUrl}${url}${reasonId}`;
    return this.http.get(queryUrl);
  }

  getImprint(appid: number): Observable<any> {
    const url = `public/imprint/`;
    const queryUrl = `${environment.baseApiUrl}${url}${appid}`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        // console.log(response.json);
        // return new Med(response.json);
        return response;
      }),
      //retryWhen(this.retryFunction)
    );
  }

  getOpenAppointement(id: number): Observable<Appointement> {
    const url = `public/appointement/open/`;
    const queryUrl = `${environment.baseApiUrl}${url}${id}`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return new Appointement(response);
      }),
      //retryWhen(this.retryFunction)
    );
  }

  getNetworkInfo(accessToken, doc): Observable<any> {
    let formData = new FormData();
    formData.append(`doc`, doc);

    const url = `private/network/getNetworkInfo`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getNetworkInfoAPI(accessToken, doc): Observable<any> {
    let formData = new FormData();
    formData.append(`doc`, doc);
    formData.append(`token`, accessToken);

    const url = `public/network/getNetworkInfoAPI`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getDocOpenAppsById(accessToken, id, start, end): Observable<any> {
    let formData = new FormData();
    let intstart = parseInt(start);
    let intend = parseInt(end);
    formData.append(`id`, id);
    //Todo update find solution
    //formData.append(`start`, moment(intstart).unix());
    //formData.append(`end`, moment(intend).unix());

    const url = `private/network/getDocOpenAppsById`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getDocOpenAppsByIdAPI(id, start, end): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);
    //Todo update find solution
    //formData.append(`start`, moment(start).unix());
    //formData.append(`end`, moment(end).unix());

    const url = `public/network/getDocOpenAppsByIdAPI`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getOwnDocOpenEvents(
    id: number,
    ins: number,
    start: Date,
    end: Date,
    reason: number
  ): Observable<Array<Appointement>> {
    let startTS = moment(start).unix();
    let endTS = moment(end).unix();
    if ((id == 1005 || id == 1724)) {
      let now = new Date();
      now.setDate(now.getDate() + 7);
      now.setHours(now.getHours() + 2);
      endTS = moment(now).unix();
      if (startTS > endTS) {
        endTS = startTS;
      }
    }
    const url = `public/doc/`;
    let reasonString = "";
    if (reason !== 0) {
      reasonString = `/${reason}`;
    }

    const queryUrl = `${environment.baseApiUrl}${url}${id}/own/events/open/${ins}/${startTS}/${endTS}${reasonString}`;
    return this.http.get(queryUrl).pipe(
      map((responseData: Response) => {
        return responseData.json;
      }),
      map((apps) => {
        const result: Array<Appointement> = [];
        if (Array.isArray(apps)) {
          apps.forEach((app) => {
            result.push(new Appointement(app));
          });
        }
        return result;
      }),
      //retryWhen(this.retryFunction)
    );
  }

  geDocOpenEvents(
    id: number,
    ins: number,
    start: Date,
    end: Date,
    reason: number
  ): Observable<Array<Appointement>> {
    let startTS = moment(start).unix();
    let endTS = moment(end).unix();
    if ((id == 1005 || id == 1724)) {
      let now = new Date();
      now.setDate(now.getDate() + 7);
      now.setHours(now.getHours() + 2);
      endTS = moment(now).unix();
      if (startTS > endTS) {
        endTS = startTS;
      }
    }
    if(this.DEBUG)console.log('Docid ApiHandler get openevents', id);
    const url = `public/doc/`;
    let reasonString = "";
    if (reason !== 0) {
      reasonString = `/${reason}`;
    }
    const queryUrl = `${environment.baseApiUrl}${url}${id}/events/open/${ins}/${startTS}/${endTS}${reasonString}`;
    return this.http.get(queryUrl).pipe(
      map((responseData: Response) => {
        return responseData;
      }),
      map((apps) => {
        const result: Array<Appointement> = [];
        if(this.DEBUG)console.log('Apps in DocPage ApiHandler', apps);
        if (Array.isArray(apps)) {  
          apps.forEach((app) => {
            result.push(new Appointement(app));
          });
        }
        return result;
      }),
      //retryWhen(this.retryFunction)
    );
    // return (<any>response.json).map(item => {
    //   return new Appointement(item);
    // });
  }

  //Todo update searchDocs 
  searchDocs(name: string): Observable<Array<SearchResult>> {
    const url = `public/search/name/`;
    const queryUrl = `${environment.baseApiUrl}${url}${name}`;

    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return (<any>response).map((item) => {
          return new SearchResult(item);
        });
      }),
      //retryWhen(this.retryFunction)
    );
  }
  searchPraxis(name: string): Observable<Array<SearchResult>> {
    const url = `public/search/praxis/`;
    const queryUrl = `${environment.baseApiUrl}${url}${name}`;
  
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return (<any>response).map((item) => {
          return new SearchResult(item);
        });
      }),
      //retryWhen(this.retryFunction)
    );
  }

  /*searchPLZ(zip: string): Observable<Array<ZipResults>> {
    const url = `public/search/plz/`;
    const queryUrl = `${environment.baseApiUrl}${url}${zip}`;
console.log(queryUrl, "PLZ");
    return this.http.get(queryUrl).pipe(
      map((response: any) => {
        return response.map((item: any) => {
          return new ZipResults(item);
        });
      })
    );
  }*/

  searchPLZ(zip: string): Observable<any> {
    let formData = new FormData();
    formData.append(`zip`, zip);

    const url = `public/search/plz`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }


  logout(accessToken: string): Observable<any> {
    const url = `private/patient/logout`;
    const queryUrl = `${environment.baseApiUrl}${url}`;

    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    return this.http
      .delete(queryUrl, {
        headers: headers,
      });
  }

  logoutNetwork(accessToken: string): Observable<any> {
    const url = `private/network/logout`;
    const queryUrl = `${environment.baseApiUrl}${url}`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    return this.http
      .delete(queryUrl, {
        headers: headers,
      });
  }

 /* searchDocsWithAppointements(
    spec: number,
    zip: string,
    radius: number,
    ins: number,
    start: Date,
    sort: number
  ): Observable<Array<SearchResult>> {
    const startTS = moment(start).unix();
    const url = `public/search/appointement/`;
    const queryUrl = `${environment.baseApiUrl}${url}${spec}/${zip}/${radius}/${ins}/${startTS}/${sort}`;

    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return (<any>response).map((item) => {
          return new SearchResult(item);
        });
      }),
      //retryWhen(this.retryFunction)
    );
  }*/

  searchDocsWithAppointements(
      spec: number,
      zip: string,
      radius: number,
      ins: number,
      sort: number,
    ): Observable<Array<SearchResult>> {
      const url = `public/search/doctor/`;
      let queryUrl = `${environment.baseApiUrl}${url}${spec}/${zip}/${radius}/${ins}/${sort}`;
  
      return this.http.get(queryUrl).pipe(
        map((response: Response) => {
        
          return (<any>response).map((item) => {
            return new SearchResult(item);
          });
      }),
      //retryWhen(this.retryFunction)
    );
  }
  

  getDocsForStandort(standortId: number): Observable<Array<Doctor>> {
    const url = `public/standort/`;
    const queryUrl = `${environment.baseApiUrl}${url}${standortId}/docs`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return (<any>response.json).map((item) => {
          return new Doctor(item);
        });
      }),
      //retryWhen(this.retryFunction)
    );
  }

  getNewAccessToken(refreshToken: string): Observable<any> {
    /*const body: string = [
      `client_secret=${AppSettings.FS_API_KEY}`,
      `client_id=${AppSettings.FS_API_client}`,
      `refresh_token="${encodeURIComponent(refreshToken)}"`,
      `scope=patient_full_access`,
      `grant_type=refresh_token`,
    ].join("&");*/

    let formData = new FormData();
    formData.append("client_secret", AppSettings.FS_API_KEY);
    formData.append("client_id", AppSettings.FS_API_client);
    formData.append("refresh_token", encodeURIComponent(refreshToken));
    formData.append("scope", 'patient_full_access');
    formData.append("grant_type", 'refresh_token');

    const url = `public/login`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  //Todo Check Function
  getPatient(accessToken: string): Observable<Patient> {
    const url = `private/patient`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      })
      .pipe(
        map((response) => {
          return new Patient(response);
        }),
        //retryWhen(this.retryFunction)
      );
    
  }

  getBMP(accessToken: string): Observable<any> {
    const url = `private/patient/bmp`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getAllBMPs(accessToken: string): Observable<any> {
    const url = `private/patient/getPatMeds`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getAllDocs(accessToken: string): Observable<any> {
    const url = `private/doctor/doctors`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getDocGroups(accessToken) {
    const url = `private/doctor/dashboard/getDocGroups`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getBarcode(accessToken: string): Observable<any> {
    const url = `private/patient/bmp/barcode`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getBMPSharePin(accessToken: string): Observable<any> {
    const url = `private/patient/bmp/share`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getBMPBySharePin(accessToken: string, code: string): Observable<any> {
    const url = `private/patient/bmp/share/`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}${code}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  saveBMP(
    accessToken: string,
    data: any,
    uid: string,
    page: number,
    pages: number
  ): Observable<any> {
    /*const body: string = [
      `data=${encodeURIComponent(data)}`,
      `uid=${encodeURIComponent(uid)}`,
      `page=${page}`,
      `pages=${pages}`,
    ].join("&");*/

    let formData = new FormData();
   // formData.append("data", encodeURIComponent(data));
   // formData.append("uid", encodeURIComponent(uid));
    formData.append("data", data);
    formData.append("uid", uid);
    formData.append("page", page.toString());
    formData.append("pages", pages.toString());


    const url = `private/patient/bmp`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  bookEventByDoc(accessToken: string, patient, event, userId:number = 0): Observable<any> {
    let formData = new FormData();
    formData.append("doc", event.doc);
    formData.append("eventid", event.eventId);
    formData.append("reason", event.reason);
    formData.append("comment", event.comment);
    formData.append("gender", patient.gender);
    formData.append("firstname", patient.firstname);
    formData.append("lastname", patient.lastname);
    formData.append("phone", patient.phone);
    formData.append("mail", patient.mail);
    formData.append("address", patient.address);
    formData.append("zip", patient.zip);
    formData.append("city", patient.city);
    formData.append("birthday", patient.birthday);
    formData.append("ins", patient.insurance);
    formData.append("u", userId.toString());

    const url = `private/doctor/dashboard/book`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    let queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }

  bookAppointment(accessToken: string, app: Appointement, patientData: any, comment: string) {
    let formData = new FormData();
    formData.append(`comment`, comment);

    formData.append(`gender`, patientData.gender);
    formData.append(`name`, patientData.name);
    formData.append(`surname`, patientData.surname);
    formData.append(`birthday`, patientData.birthday);
    formData.append(`insurance`, patientData.insurance);
    formData.append(`email`, patientData.email);
    formData.append(`phone`, patientData.phone);
    formData.append(`msg`, patientData.msg);

    formData.append(`start`, app.start.toString());
    formData.append(`docID`, app.doctor);

    const url = `private/network/bookAppointment`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  bookAppointmentAPI(accessToken: string, app: Appointement, patientData: any, comment: string) {
    let formData = new FormData();
    //formData.append(`comment`, comment);

    formData.append(`gender`, patientData.gender);
    formData.append(`name`, patientData.name);
    formData.append(`surname`, patientData.surname);
    formData.append(`birthday`, patientData.birthday);
    formData.append(`insurance`, patientData.insurance);
    formData.append(`email`, patientData.email);
    formData.append(`phone`, patientData.phone);
    formData.append(`comment`, patientData.msg);

    formData.append(`start`, app.start.toString());
    formData.append(`docID`, app.doctor);
    formData.append(`token`, accessToken);

    const url = `public/network/bookAppointmentAPI`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  bookEventfromDoc(
    doc,
    accessToken: string,
    event: Appointement,
    symptoms: string,
    forId: number,
    forOtherName: string,
    forOtherLastName: string,
    forOtherBirthday: string,
    insKKNumber: string,
    insName: string,
    insNumber: string,
    insStatus: string,
    egkF: File,
    egkB: File,
    attachments,
    email: string,
    emailcheck: boolean,
    patientarray
  ): Observable<any> {
    // sending multipart form data
    if (this.DEBUG) console.log(egkF, egkB, attachments);
    if (egkF != null || egkB != null || attachments.length != 0 ||
      insKKNumber != null || insName != null || insNumber != null || insStatus != null) {
      let formData = new FormData();
      formData.append("doctor", doc);
      formData.append("symptoms", symptoms);
      formData.append("forId", forId.toString());
      formData.append("third_name", forOtherName);
      formData.append("third_surname", forOtherLastName);
      formData.append("third_born", forOtherBirthday);
      formData.append("insKKNumber", insKKNumber);
      formData.append("insName", insName);
      formData.append("insNumber", insNumber);
      formData.append("insStatus", insStatus);
      formData.append("exp_gender", patientarray.anr);
      formData.append("exp_name", patientarray.firstname);
      formData.append("exp_surname", patientarray.lastname);
      formData.append("exp_address", patientarray.address);
      formData.append("exp_zip", patientarray.zip);
      formData.append("exp_city", patientarray.city);
      formData.append("exp_insurance", patientarray.insurance);
      formData.append("exp_email", patientarray.email);
      formData.append("exp_birthday", patientarray.birthday);
      formData.append("exp_city", patientarray.city);
      formData.append("exp_phone", patientarray.phone);
      formData.append("emailcheck", emailcheck == true ? '1' : '0');

      const url = `private/doctor/dashboard/bookfromdoc`;
      const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
      let queryUrl = `${environment.baseApiUrl}${url}`;
      if (event.reason) {
        formData.append("docID", event.doctor);
        formData.append("reasonID", event.reason.toString());
        formData.append(
          "start",
          moment(event.start).format("YYYY-MM-DD HH:mm:ss")
        );
      } else {
        queryUrl += `/${event.id}`;
      }

      if (egkF != null) {
        formData.append("egkf", egkF, egkF.name);
      }
      if (egkB != null) {
        formData.append("egkb", egkB, egkB.name);
      }
      if (attachments != null) {
        attachments.forEach((file) => {
          formData.append("attachments[]", file.rawFile, file.name);
        });
      }
      return this.http
        .post(queryUrl, formData, {
          headers: headers,
        })
        .pipe(
          map((response: Response) => {
            return response.json;
          }),
          //retryWhen(this.retryFunction)
        );
    } else {
      // TODO: change to formdata
      /*let data: Array<string> = [
        `symptoms=${symptoms}`,
        `forId=${forId}`,
        `third_name=${forOtherName}`,
        `third_surname=${forOtherLastName}`,
        `third_born=${forOtherBirthday}`,
        `email=${email}`,
        `docID=${doc}`,
        `emailcheck=${emailcheck}`,
        `patientarray=${patientarray}`,
      ];*/

     
      let formData = new FormData();

      const url = `private/doctor/dashboard/bookfromdoc`;
      const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
      let queryUrl = `${environment.baseApiUrl}${url}`;
      formData.append("symptoms", symptoms);
      formData.append("forId", forId.toString());
      formData.append("third_name", forOtherName);
      formData.append("third_surname", forOtherLastName);
      formData.append("third_born", forOtherBirthday);
      formData.append("email", email);
      formData.append("docID", doc);
      formData.append("emailcheck", emailcheck.toString());
      formData.append("patientarray", patientarray);


      if (event.reason) {
        /*data.push(
          `docID=${+event.doctor}`,
          `reasonID=${+event.reason}`,
          `start=${moment(event.start).format("YYYY-MM-DD HH:mm:ss")}`
        );*/
        formData.append("docID", doc+event.doctor);
          formData.append("reasonID", event.reason.toString());
          formData.append("start", moment(event.start).format("YYYY-MM-DD HH:mm:ss"));
      } else {
        queryUrl += `/${event.id}`;
      }
      //const body = data.join("&");
      return this.http
        .post(queryUrl, formData, {
          headers: headers,
        })
        .pipe(
          map((response: Response) => {
            return response.json;
          }),
          //retryWhen(this.retryFunction)
        );
    }
  }

  bookEvent(
    accessToken: string,
    event: Appointement,
    symptoms: string,
    forId: number,
    forOtherName: string,
    forOtherLastName: string,
    forOtherBirthday: string,
    insKKNumber: string,
    insName: string,
    insNumber: string,
    insStatus: string,
    egkF: File,
    egkB: File,
    attachments,
    group,
    chain = 0,
    chainapp
  ): Observable<any> {
    // sending multipart form data
    if (this.DEBUG) console.log(egkF, egkB, attachments);
    if (group == undefined) {
	    group = false;
	  }
    if (egkF != null || egkB != null || attachments.length != 0 ||
      insKKNumber != null || insName != null || insNumber != null || insStatus != null) {
      let formData = new FormData();

      formData.append("symptoms", symptoms);
      formData.append("forId", forId.toString());
      formData.append("third_name", forOtherName);
      formData.append("third_surname", forOtherLastName);
      formData.append("third_born", forOtherBirthday);
      formData.append("insKKNumber", insKKNumber);
      formData.append("insName", insName);
      formData.append("insNumber", insNumber);
      formData.append("insStatus", insStatus);
      formData.append("group", group.toString());
      formData.append("chain", chain.toString());
      formData.append("chainapps", chainapp)
      const url = `private/patient/book`;
      const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
      let queryUrl = `${environment.baseApiUrl}${url}`;
      if (event.reason) {
        formData.append("docID", event.doctor);
        formData.append("reasonID", event.reason.toString());
        formData.append(
          "start",
          moment(event.start).format("YYYY-MM-DD HH:mm:ss")
        );
        formData.append(
          "end",
          moment(event.end).format("YYYY-MM-DD HH:mm:ss")
        );
      } else if (chain==1) {
        if(this.DEBUG)console.log('ischain', chain);
      } else {
        queryUrl += `/${event.id}`;
      }


      if (egkF != null) {
        formData.append("egkf", egkF, egkF.name);
      }
      if (egkB != null) {
        formData.append("egkb", egkB, egkB.name);
      }
      if (attachments != null) {
        attachments.forEach((file) => {
          formData.append("attachments[]", file.rawFile, file.name);
        });
      }
      return this.http
        .post(queryUrl, formData, {
          headers: headers,
        })
        .pipe(
          map((response: Response) => {
            return response;
          }),
          //retryWhen(this.retryFunction)
        );
    } else {
      let formData = new FormData();
      formData.append("symptoms", symptoms);
      formData.append("forId", forId.toString());
      formData.append("third_name", forOtherName);
      formData.append("third_surname", forOtherLastName);
      formData.append("third_born", forOtherBirthday);


      const url = `private/patient/book`;
      const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
      let queryUrl = `${environment.baseApiUrl}${url}`;
      if (event.reason) {
        formData.append("docID", event.doctor);
        formData.append("reasonID", event.reason.toString());
        formData.append(
          "start",
          moment(event.start).format("YYYY-MM-DD HH:mm:ss")
        );
        formData.append(
          "end",
          moment(event.end).format("YYYY-MM-DD HH:mm:ss")
        );
        /*data.push(
          `docID=${+event.doctor}`,
          `reasonID=${+event.reason}`,
          `start=${moment(event.start).format("YYYY-MM-DD HH:mm:ss")}`
        );*/
      } else {
        queryUrl += `/${event.id}`;
      }
     /// const body = data.join("&");
     if(this.DEBUG)console.log(formData, queryUrl);

      return this.http
        .post(queryUrl, formData, {
          headers: headers,
        })
        .pipe(
          map((response: Response) => {
            return response;
          }),
          //retryWhen(this.retryFunction)
        );
    }
  }

  checkDependencies(accessToken: string, eventId: number): Observable<any> {
    let formData = new FormData();

    formData.append("eventId", eventId.toString());

    const url = `private/patient/checkDependencies`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    let queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  setDependencies(accessToken: string, dependencyIds: Array<any>): Observable<any> {
    let formData = new FormData();

    formData.append("dependencies", dependencyIds.join("|"));

    const url = `private/patient/setDependencies`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    let queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  checkMaxBookings(docId, reason, start): Observable<any> {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("doc", docId);
    formData.append("reason", reason);

    if(this.DEBUG)console.log('formData', formData);
    const url = `public/checkMaxBookings`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      })
      .pipe(
        map((response: Response) => {
          if(this.DEBUG)console.log('response', response);
          return response;
        }),
        //retryWhen(this.retryFunction)
      );
  }

  blockAppointment(appid, start, doc, reason): Observable<any> {
    let formData = new FormData();

    if (appid != undefined) {
      formData.append("appid", appid);

    } else {
      formData.append("start", start);
      formData.append("doc", doc);
      formData.append("reason", reason);
    }
    if(this.DEBUG)console.log('formData', formData);
    const url = `public/patient/blockAppointment`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      })
      .pipe(
        map((response: Response) => {
          if(this.DEBUG)console.log('response', response);
          return response;
        }),
        //retryWhen(this.retryFunction)
      );
  }

  enterWaitinglist(accessToken: string, doc, dateTo): Observable<any> {
   // const body: string = [`doc=${doc}`, `dateTo=${dateTo}`].join("&");
    let formData = new FormData();
    formData.append("doc", doc);
    formData.append("dateTo", dateTo);

    const url = `private/patient/enterWaitinglist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
    .post(queryUrl, formData, {
      headers: headers,
    })
    .pipe(
      map((response: Response) => {
        return response;
      }),
      //retryWhen(this.retryFunction)
    );
  }

  deleteMessage(accessToken: string, messageId: string): Observable<any> {
    //const body: string = [`messageId=${messageId}`].join("&");
    let formData = new FormData();
    formData.append("messageId", messageId);

    const url = `private/patient/messages/delete`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  readStatusMessage(accessToken: string, messageId: string): Observable<any> {
    //const body: string = [`messageId=${messageId}`].join("&");

    let formData = new FormData();
    formData.append("messageId", messageId);

    const url = `private/patient/messages/read`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveNotificationToken(
    accessToken: string,
    noti_token: string
  ): Observable<any> {
    //const body: string = [`device=${noti_token}`].join("&");
    let formData = new FormData();
    formData.append("device", noti_token);

    const url = `private/patient/notification/set`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getRequestSettingsById(
    accessToken: string,
    docId: number
  ): Observable<any> {
   /* const body: string = [
      `docId=${docId}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("docId", docId.toString());

    const url = `private/patient/getRequestSettingsById`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}/${docId}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  sendMedMsg(accessToken, docId, pzn, names, message): Observable<any> {
   /* const body: string = [
      `docId=${docId}`,
      `pzn=${pzn.toString()}`,
      `names=${names.toString()}`,
      `message=${message}`,
    ].join("&");*/

    let formData = new FormData();
    formData.append("docId", docId);
    formData.append("pzn", pzn.toString());
    formData.append("names", names.toString());
    formData.append("message", message);

    const url = `private/patient/sendMedMsg`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  sendMessage(
    accessToken: string,
    docId: number,
    message: string,
    type: number,
    med: Array<any>,
    pzn: Array<any>,
    practice: Array<any>,
    thirds, thirdsname, thirdssurname, thirdsbirth
  ): Observable<any> {
   /* const body: string = [
      `message=${message}`,
      `type=${type}`,
      `med=${med}`,
      `pzn=${pzn}`,
      `practice=${practice}`,
      `thirds=${thirds}`,
      `thirdsname=${thirdsname}`,
      `thirdssurname=${thirdssurname}`,
      `thirdsbirth=${thirdsbirth}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("message", message);
    formData.append("type", type.toString());
    formData.append("med", med.toString());
    formData.append("pzn", pzn.toString());
    formData.append("practice", practice.toString());
    formData.append("thirds", thirds);
    formData.append("thirdsname", thirdsname);
    formData.append("thirdssurname", thirdssurname);
    formData.append("thirdsbirth", thirdsbirth);


    const url = `private/patient/message`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}/${docId}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getMessages(accessToken: string, name: string): Observable<Array<Message>> {
    const url = `private/patient/messages`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      })
      .pipe(
        map((response: Response) => {
          return (<any>response).map((item) => {
            item.reciever = name;
            return new Message(item);
          });
        }),
        //retryWhen(this.retryFunction)
      );
  }

  cancelEvent(
    accessToken: string,
    eventId: string,
    symptoms: string
  ): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "cancelEvent request", eventId, symptoms);
    }
    //const body: string = [`symptoms=${symptoms}`].join("&");
    let formData = new FormData();
    formData.append("symptoms", symptoms);

    const url = `private/patient/cancel`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}/${eventId}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveNotification(
    accessToken: string,
    type: string,
    data: string
  ): Observable<any> {
    //const body: string = [`type=${type}`, `data=${data}`].join("&");

    let formData = new FormData();
    formData.append("type", type);
    formData.append("data", data);

    const url = `private/patient/changeNotification`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  loadNotification(accessToken: string): Observable<any> {
    const url = `private/patient/loadNotification`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getPackagesByDoc(docid: number) {
    //const body: string = [`docid=${docid}`].join("&");
    let formData = new FormData();
    formData.append("docid", docid.toString());

    const headers = new HttpHeaders();
    headers.append("Accept", "1.0");
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const url = `public/doctor/getPackagesByDoc`;

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      })
      .pipe(
        map((response: Response) => {
          return response;
        }),
      );
  }

  saveUserData(
    accessToken: string,
    type: string,
    data: string
  ): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveUserData request", type, data);
    }
    //const body: string = [`type=${type}`, `data=${data}`].join("&");

    let formData = new FormData();
    formData.append("type", type);
    formData.append("data", data);

    const url = `private/patient/change`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }


  getPatientOpenApps(accessToken: string): Observable<any> {
    const url = `private/patient/open`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .get(queryUrl, {
        headers: headers,
      }) 
      .pipe(
         map((response: Response) => {
          return response;
          //return new Appointement(response);
        }),
        //retryWhen(this.retryFunction)
      );
  }
  getPatientOpenAppsOld(accessToken: string): Observable<Appointement> {
    const url = `private/patient/open`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .get(queryUrl, {
        headers: headers,
      }) 
      .pipe(
         map((response: Response) => {
          if(this.DEBUG)console.log('API-HANDLER OPENAPPS', Response);

          return (<any>response.json).map((openApps) => {
            if(this.DEBUG)console.log('API-HANDLER OPENAPPS', Response);
            return new Appointement(openApps);
          });

        }),
        //retryWhen(this.retryFunction)
      );
  }

  getPatientAppHistory(
    accessToken: string,
    offset: number = AppSettings.APP_HISTORY_OFFSET,
    limit: number = AppSettings.APP_HISTORY_INTERVAL
  ): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "getPatientAppHistory", offset, limit);
    }

    const url = `private/patient/completed/${offset}/${limit}`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    // TODO create Appointement Object with doc Info
    return this.http
      .get(queryUrl, {
        headers: headers,
      })
      .pipe(
        map((responseData: Response) => {
          //console.log('responseDATA APIHandler History', responseData);
          return responseData;
        }),
        /* map((apps) => {
          const result: Array<Appointement> = [];
          if (Array.isArray(apps)) {
            apps.forEach((app) => {
              result.push(new Appointement(app));
            });
          }
          return result;
        }), */
        //retryWhen(this.retryFunction)
      );
  }

  getPatientAppsbyDoc(
    accessToken: string
    , docId: number
  ): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "getPatientAppsbyDoc", docId);
    }

    const url = `private/patient/quarterApps/${docId}`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers
      })
      .pipe(
        map((responseData: Response) => {
          return responseData;
        })
        //retryWhen(this.retryFunction)
      );
  }


  checkMail(email: string, isDoc: string) {
    let url = ``;
    if (isDoc === "1") {
      url = `public/doctor/checkmail/`;
    } else {
      url = `public/patient/checkmail/`;
    }

    const queryUrl = `${environment.baseApiUrl}${url}${email}`;

    return this.http.get(queryUrl);
  }

  changeMail(oldEmail: string, newEmail: string, password: string, AccessToken: string): Observable<any> {
    // Korrekt formatierte URL mit den Parametern
    const url = `private/patient/changeMail`;
    const queryUrl = `${environment.baseApiUrl}${url}`;
    //const body: string = [`type=${type}`, `data=${data}`].join("&");

    let formData = new FormData();
    formData.append("oldEmail", oldEmail);
    formData.append("newEmail", newEmail);
    formData.append("password", password);
    
    // Logge die URL und Parameter zur Überprüfung
    //console.log('Request URL:', queryUrl);
    //console.log('Parameters: oldEmail =', oldEmail, ', newEmail =', newEmail, ', password =', password);

    // HTTP-Anfrage mit dem Access-Token
    const headers = new HttpHeaders().set('Authorization', `Bearer ${AccessToken}`);

    // Führe den HTTP-Request aus
    return this.http.post(queryUrl, formData, { headers }).pipe(
        tap(response => {
            // Logge die API-Antwort und bestätige die Parameter
            //console.log('API Response:', response);
        }),
        map((response: any) => {
            // Prüfe die Antwort der Backend-Funktion und gib entsprechend zurück
            if (response?.success === true) {
                // Erfolgsfall: E-Mail wurde erfolgreich geändert
                return { success: true, message: response?.message || 'E-Mail erfolgreich geändert.' };
            } else if (response?.success === false && response?.message === 'Error: New email already exists') {
                // Fehlerfall: Neue E-Mail ist bereits vergeben
                return { success: false, message: 'E-Mail bereits vergeben.' };
            } else {
                // Andere mögliche Fehler
                return { success: false, message: response?.message || 'Unbekannter Fehler aufgetreten.' };
            }
        }),
        catchError(error => {
            // Logge den Fehler und die Parameter für Debugging
            //console.error('Error occurred:', error);
            //console.log('Failed Parameters: oldEmail =', oldEmail, ', newEmail =', newEmail, ', password =', password);
            return of({ success: false, message: 'Fehler bei der Anfrage.' }); // Fehlerbehandlung
        })
    );
  }

  getPatientFrequentDocs(accessToken: string) {
    const url = `private/patient/docs/favorites/${AppSettings.LIMIT_PATIENT_FREQUENT_DOCS}`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      })
      .pipe(
        map((response: Response) => {
          return response;
        }),
        //retryWhen(this.retryFunction)
      );
  }

  getPractice(id: number): Observable<Practice> {
    if(this.DEBUG)console.log('getPraxisInfo', id);
    const url = `public/practice/`;
    const queryUrl = `${environment.baseApiUrl}${url}${id}`;
    return this.http.get(queryUrl).pipe(
      map((response: Response) => {
        return new Practice(response);
      }),
      //retryWhen(this.retryFunction)
    );
  }

  /*
   * Doc API
   */

  getSubDocs(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getSubDocs");
    }

    const url = `private/doctor/dashboard/subdocs`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      })
      .pipe(
        map((responseData: Response) => {
          return responseData.json;
        }),
        map((docs) => {
          const result: Array<Doctor> = [];

          if (Array.isArray(docs)) {
            docs.forEach((doc) => {
              result.push(new Doctor(doc, true));
            });
          }
          return result;
        }),
        //retryWhen(this.retryFunction)
      );
  }

  getWidgetConfig(accessToken, docId) {
    if (this.DEBUG) {
      console.log(this.TAG, "getWidgetConfig");
    }

    const url = `private/doctor/dashboard/widgetConfig`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;
   // const body: string = [`docId=${docId}`].join("&");

    let formData = new FormData();
    formData.append("docId", docId);

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getViomedi(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getViomedi");
    }

    const url = `private/doctor/dashboard/getViomedi`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  connectToViomedi(accessToken, vioMail, vioPw) {
    if (this.DEBUG) {
      console.log(this.TAG, "connectToViomedi");
    }

    const url = `private/doctor/dashboard/viomediConnect`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;
    //const body: string = [`vioMail=${vioMail}`, `vioPw=${vioPw}`].join("&");

    let formData = new FormData();
    formData.append("vioMail", vioMail);
    formData.append("vioPw", vioPw);


    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  disconnectFromViomedi(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "disconnectFromViomedi");
    }

    const url = `private/doctor/dashboard/viomediDisconnect`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getAllEventsForDoc(accessToken, calendar, start, end) {
    if (this.DEBUG) {
      console.log(this.TAG, "getAllEvents", calendar, start, end);
    }

    const url = `private/doctor/dashboard/events`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;
    /*const body: string = [
      `docId=${calendar}`,
      `start=${start}`,
      `end=${end}`,
    ].join("&");*/

    let formData = new FormData();
    formData.append("docId", calendar);
    formData.append("start", start);
    formData.append("end", end);

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      })
      .pipe(
        map((responseData: Response) => {
          return responseData.json;
        }),
        map((apps) => {
          const result: Array<Appointement> = [];
          if (Array.isArray(apps)) {
            apps.forEach((app) => {
              app.doctor = calendar;
              result.push(new Appointement(app));
            });
          }
          return result;
        }),
        //retryWhen(this.retryFunction)
      );
  }

  getSentSms(accessToken) {
    const url = `private/doctor/dashboard/getSentSms`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getSmsArchive(accessToken) {
    const url = `private/doctor/dashboard/getSmsArchive`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getGroupData(accessToken) {
    const url = `private/doctor/dashboard/getGroupData`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getDocData(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getDocData");
    }

    const url = `private/doctor/dashboard/profile`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  checkikvnr(ik: string) {
    let url = `public/system/checkikvnr/`;

    const queryUrl = `${environment.baseApiUrl}${url}${ik}`;

    return this.http.get(queryUrl);
  }

  getPlugins(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getPlugins");
    }

    const url = `private/doctor/dashboard/getPlugins`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  removePlugin(accessToken, id) {
    if (this.DEBUG) {
      console.log(this.TAG, "removePlugin");
    }
    let formData = new FormData();
    formData.append(`id`, id);

    const url = `private/doctor/dashboard/removePlugin`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  savePlugin(accessToken, data) {
    if (this.DEBUG) {
      console.log(this.TAG, "savePlugin");
    }
    let formData = new FormData();
    formData.append(`pluginName`, data.pluginName);
    formData.append(`active`, data.active);

    const url = `private/doctor/dashboard/savePlugin`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editPlugin(accessToken, data) {
    if (this.DEBUG) {
      console.log(this.TAG, "editPlugin");
    }
    let formData = new FormData();
    formData.append(`id`, data.id);
    formData.append(`pluginName`, data.pluginName);
    formData.append(`active`, data.active);

    const url = `private/doctor/dashboard/editPlugin`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  loadPluginConfig(accessToken, pluginToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "loadPlugin");
    }
    let formData = new FormData();
    formData.append(`pluginToken`, pluginToken);

    const url = `private/doctor/dashboard/loadPluginConfig`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  savePluginConfig(accessToken, pluginToken, data) {
    if (this.DEBUG) {
      console.log(this.TAG, "savePluginConfig");
    }
    let formData = new FormData();
    formData.append(`pluginToken`, pluginToken);
    formData.append(`activate`, data.activate);
    formData.append(`fullClient`, data.fullClient == true ? "1" : "0");
    formData.append(`size`, data.size);
    formData.append(`showBorder`, data.showBorder == true ? "1" : "0");
    formData.append(`color`, data.color);
    formData.append(`time`, data.time);
    formData.append(`recipeOnly`, data.recipeOnly == true ? "1" : "0");
    formData.append(`requestButton`, data.requestButton == true ? "1" : "0");

    formData.append(`welcomeText`, data.welcomeText);
    formData.append(`welcomeTitle`, data.welcomeTitle);
    formData.append(`showLogo`, data.showLogo == true ? "1" : "0");
    formData.append(`showLinks`, data.showLinks == true ? "1" : "0");
    formData.append(`showDoctor`, data.showDoctor == true ? "1" : "0");
    formData.append(`requestButtonText`, data.requestButtonText);
    formData.append(`reasonQuestionText`, data.reasonQuestionText);
    formData.append(`reasonActionText`, data.reasonActionText);
    formData.append(`customReasons`, data.customReasons == true ? "1" : "0");
    formData.append(`customName`, data.customName);
    formData.append(`showOnlyFirstEvent`, data.showOnlyFirstEvent == "" ? "0" : data.showOnlyFirstEvent);
    formData.append(`showEventList`, data.showEventList == true ? "1" : "0");
    formData.append(`showSingleReasonEvents`, data.showSingleReasonEvents == true ? "1" : "0");
    formData.append(`showDoctorSelect`, data.showDoctorSelect == true ? "1" : "0");
    formData.append(`doctorQuestionText`, data.doctorQuestionText);
    formData.append(`doctorActionText`, data.doctorActionText);
    let dls = [];
    data.docListSelected.forEach(element => {
      dls.push(element.id);
    });
    formData.append(`docListSelected`, dls.join(','));
    let rs = [];
    data.reasonsSelected.forEach(element => {
      element.treatment_reasons.forEach(e => {
        rs.push(e.id);
      });
    });
    formData.append(`reasonsSelected`, rs.join(','));

    const url = `private/doctor/dashboard/savePluginConfig`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }


  //Todo update solution

  /* getPackagesByDoc(docid: number) {
    const body: string = [`docid=${docid}`].join("&");
    const headers = new Headers();
    headers.append("Accept", "1.0");
    headers.append("Content-Type", "application/x-www-form-urlencoded");

    const url = `public/doctor/getPackagesByDoc`;

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, body, {
        headers: headers,
      })
      .pipe(
        map((response: Response) => {
          return response.json();
        }),
        retryWhen(this.retryFunction)
      );
  } */



   

  getPracticeData(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getPracticeData");
    }

    const url = `private/doctor/dashboard/practice`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

 /* savePractice(accessToken: string, practice: Practice, userId:number=0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "savePractice request", practice);
    }

    let formData = new FormData();
    formData.append(`praxis_name`, practice.praxis);
    formData.append(`tel`, practice.tel);
    formData.append(`address`, practice.address);
    formData.append(`zip`, practice.zip);
    formData.append(`city`, practice.city);

    formData.append(`praxis_info`, practice.info);
    formData.append(`ausbildung`, practice.ausbildung);
    formData.append(`philo`, practice.philo);
    formData.append(`leistung`, practice.leistung);
    formData.append(`lang`, practice.lang);
    formData.append(`web`, practice.web);

    formData.append(`u`,userId.toString());

    if (practice.images.length > 0) {
      practice.images.forEach(i => {
        formData.append(`imgs[]`, i.rawFile, i.name);
      });
    }

    const url = `private/doctor/practice`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }*/

  removePracticeImages(accessToken: string, rmImages): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "removePracticeImages request", rmImages);
    }

    let formData = new FormData();
    formData.append('images', rmImages.join(','));

    const url = `private/doctor/removePracticeImages`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  updatePracticeImage(accessToken: string, images): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "updatePracticeImage request", images);
    }

    let formData = new FormData();
    formData.append('images', JSON.stringify(images));

    const url = `private/doctor/updatePracticeImage`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveStatisticsGroup(accessToken, group, name): Observable<any> {
    let formData = new FormData();
    formData.append(`group`, group);
    formData.append(`name`, name);

    const url = `private/doctor/dashboard/saveStatisticsGroup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveDocSms(accessToken, arztid, paket, addcal, s1000, s500, s250): Observable<any> {
    let formData = new FormData();
    formData.append(`arztid`, arztid);
    formData.append(`paket`, paket);
    formData.append(`addcal`, addcal);
    formData.append(`s1000`, s1000);
    formData.append(`s500`, s500);
    formData.append(`s250`, s250);

    const url = `private/doctor/dashboard/saveDocSms`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  removeBookedAddCalendar(accessToken, calendar): Observable<any> {
    let formData = new FormData();
    formData.append(`calendar`, calendar);

    const url = `private/doctor/dashboard/removeBookedAddCalendar`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  removeNetworkAppointmentZone(accessToken, id): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);

    const url = `private/doctor/dashboard/removeNetworkAppointmentZone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  removeNetworkAppointmentZoneAssign(accessToken, id): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);

    const url = `private/doctor/dashboard/removeNetworkAppointmentZoneAssign`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getHasNetwork(accessToken): Observable<any> {
    const url = `private/doctor/dashboard/getHasNetwork`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  deleteNetworker(accessToken, id): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);

    const url = `private/doctor/dashboard/deleteNetworker`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getNetworkDocs(accessToken): Observable<any> {
    const url = `private/network/getNetworkDocs`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getNetworkDocsByToken(accessToken): Observable<any> {
    const url = `public/network/getNetworkDocsByToken`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;
    let formData = new FormData();
    formData.append(`token`, accessToken);
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getNetworkPatientData(accessToken): Observable<any> {
    const url = `public/network/getNetworkPatientData`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;
    let formData = new FormData();
    formData.append(`token`, accessToken);
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getAppointmentById(accessToken, id): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);
    const url = `private/network/getAppointmentById`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getNetworkers(accessToken): Observable<any> {
    const url = `private/doctor/dashboard/getNetworkers`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  blockAppointmentWithoutReason(accessToken, start, doc): Observable<any> {
    let formData = new FormData();
    formData.append(`start`, start);
    formData.append(`doc`, doc);

    const url = `private/network/blockAppointmentWithoutReason`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  blockAppointmentWithoutReasonAPI(accessToken, start, doc): Observable<any> {
    let formData = new FormData();
    formData.append(`start`, start);
    formData.append(`doc`, doc);
    formData.append(`token`, accessToken);

    const url = `public/network/blockAppointmentWithoutReasonAPI`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getStepByDoc(accessToken, id): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);

    const url = `private/network/getStepByDoc`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getStepByDocAPI(accessToken, id): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, id);
    formData.append(`token`, accessToken);

    const url = `public/network/getStepByDocAPI`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getStep(accessToken): Observable<any> {
    const url = `private/doctor/dashboard/getStep`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  saveSummaryApps(accessToken, summaryApps, networkerId): Observable<any> {
    let formData = new FormData();
    formData.append(`summaryApps`, summaryApps);
    formData.append(`networkerId`, networkerId);

    const url = `private/doctor/dashboard/saveSummaryApps`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveStep(accessToken, step): Observable<any> {
    let formData = new FormData();
    formData.append(`step`, step);

    const url = `private/doctor/dashboard/saveStep`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  createNetwork(accessToken, email, firstname, lastname): Observable<any> {
    let formData = new FormData();
    formData.append(`email`, email);
    formData.append(`firstname`, firstname);
    formData.append(`lastname`, lastname);

    const url = `private/doctor/dashboard/createNetwork`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editDocGroup(accessToken, groupid, groupName, newIds, deleteIds): Observable<any> {
    let formData = new FormData();
    formData.append(`groupid`, groupid.toString());
    formData.append(`groupName`, groupName.toString());
    formData.append(`newIds`, newIds.toString());
    formData.append(`deleteIds`, deleteIds.toString());

    if(this.DEBUG)console.log('formData', formData);

    const url = `private/doctor/dashboard/editDocGroup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveDocGroup(accessToken, group, name): Observable<any> {
    let formData = new FormData();
    formData.append(`group`, group);
    formData.append(`name`, name);

    const url = `private/doctor/dashboard/saveDocGroup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getRequestSettings(accessToken, docId) {
    if (this.DEBUG) {
      console.log(this.TAG, "getRequestSettings");
    }
   // const body: string = [`docId=${docId}`].join("&");

    let formData = new FormData();
    formData.append(`docId`, docId);

    const url = `private/doctor/dashboard/getrequestsettings`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getRequestText(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getColors");
    }
    const url = `private/doctor/dashboard/getRequestText`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getColors(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getColors");
    }
    const url = `private/doctor/dashboard/getcolors`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getPermissionForBooking(accessToken) {
    const url = `private/doctor/dashboard/getbookingpermission`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  saveRequestSettings(accessToken: string, docId, requestRecipe: boolean, requestTransfer: boolean, requestAppointment: boolean, requestGeneral: boolean, requestCustom: boolean, requestCustomText): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "savePractice request", requestRecipe, requestTransfer, requestAppointment, requestGeneral);
    }

    let formData = new FormData();
    formData.append(`docId`, docId.toString());
    formData.append(`requestRecipe`, requestRecipe.toString());
    formData.append(`requestTransfer`, requestTransfer.toString());
    formData.append(`requestAppointment`, requestAppointment.toString());
    formData.append(`requestGeneral`, requestGeneral.toString());
    formData.append(`requestCustom`, requestCustom.toString());
    formData.append(`requestCustomText`, requestCustomText.toString());

    const url = `private/doctor/dashboard/saverequestsettings`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveRequestText(accessToken: string, requestText): Observable<any> {
    let formData = new FormData();
    formData.append(`requestText`, requestText);

    const url = `private/doctor/dashboard/saveRequestText`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveColor(accessToken: string, colorFreeApps: string, colorbookedTermed: string, colorbookedPvs: string, colorCanceled: string, userId:number = 0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "savePractice request", colorFreeApps, colorbookedTermed, colorbookedPvs, colorCanceled);
    }

    let formData = new FormData();
    formData.append(`colorFreeApps`, colorFreeApps);
    formData.append(`colorbookedTermed`, colorbookedTermed);
    formData.append(`colorbookedPvs`, colorbookedPvs);
    formData.append(`colorCanceled`, colorCanceled);
    formData.append(`u`,userId.toString());
    const url = `private/doctor/dashboard/savecolors`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editTreatmentreason(accessToken: string, treatmentreason): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "editTreatmentreason request", treatmentreason);
    }
    let formData = new FormData();
    if (treatmentreason.docidscreate.length) {
      formData.append(`docidscreate`, treatmentreason.docidscreate);
    }
    if (treatmentreason.reasonidsedit.length) {
      formData.append(`reasonidsedit`, treatmentreason.reasonidsedit);
    }
    if (treatmentreason.reasonidsdelete.length) {
      formData.append(`reasonidsdelete`, treatmentreason.reasonidsdelete);
    }
    formData.append(`name`, treatmentreason.name);
    formData.append(`length`, treatmentreason.length);
    formData.append(`descr`, treatmentreason.descr);
    formData.append(`vss`, treatmentreason.isVss);
    formData.append(`color`, treatmentreason.color);
    formData.append(`leadTime`, treatmentreason.leadTime);
    formData.append(`maxTime`, treatmentreason.maxTime);
    formData.append(`dependency`, treatmentreason.dependency);
    formData.append(`isDependency`, treatmentreason.isDependency);
    formData.append(`isWaitingRoom`, treatmentreason.isWaitingRoom);
    formData.append(`maxBookings`, treatmentreason.maxBookings);

    formData.append(`shortTermisActive`, treatmentreason.shortTermisActive);
    formData.append(`shortTermStart`, treatmentreason.shortTermStart);
    formData.append(`stornoTime`, treatmentreason.stornoTime);
    /*formData.append(`shortTermEnd`,treatmentreason.shortTermEnd);
    formData.append(`shortTermLeadTime`,treatmentreason.shortTermLeadTime);
    formData.append(`shortTermMaxTime`,treatmentreason.shortTermMaxTime);*/

    const url = `private/doctor/edittreatmentreason`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editTreatmentreasonSingle(accessToken: string, treatmentreason, userId:number=0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "editTreatmentreason request", treatmentreason);
    }
    let formData = new FormData();
    formData.append(`docId`, treatmentreason.docId);
    formData.append(`reasonId`, treatmentreason.reasonId);
    formData.append(`name`, treatmentreason.name);
    formData.append(`length`, treatmentreason.length);
    formData.append(`descr`, treatmentreason.descr);
    formData.append(`vss`, treatmentreason.isVss);
    formData.append(`color`, treatmentreason.color);
    formData.append(`leadTime`, treatmentreason.leadTime);
    formData.append(`maxTime`, treatmentreason.maxTime);
    formData.append(`dependency`, treatmentreason.dependency);
    formData.append(`isDependency`, treatmentreason.isDependency);
    formData.append(`isWaitingRoom`, treatmentreason.isWaitingRoom);
    formData.append(`maxBookings`, treatmentreason.maxBookings);

    formData.append(`shortTermisActive`, treatmentreason.shortTermisActive);
    formData.append(`shortTermStart`, treatmentreason.shortTermStart);
    formData.append(`stornoTime`, treatmentreason.stornoTime);
    /*formData.append(`shortTermEnd`,treatmentreason.shortTermEnd);
    formData.append(`shortTermLeadTime`,treatmentreason.shortTermLeadTime);
    formData.append(`shortTermMaxTime`,treatmentreason.shortTermMaxTime);*/
    
    formData.append(`u`,userId.toString());
    
    const url = `private/doctor/edittreatmentreasonsingle`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getTreatmentReasonsAssigned(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getTreatmentReasonsAssigned");
    }
    const url = `private/doctor/gettreatmentreasonsassigned`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getAppReasonDocZone(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getTreatmentReasonsAssigned");
    }
    const url = `private/doctor/gettreatmentreasonsassignedcomplete`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  editTreatmentreasonZoneSingle(accessToken: string, treatmentreasonzone,userId:number=0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "editTreatmentreasonZone request", treatmentreasonzone);
    }
    let formData = new FormData();
    formData.append(`zonesToEdit`, treatmentreasonzone.zonesToEdit.toString());
    formData.append(`starttime`, treatmentreasonzone.starttime);
    formData.append(`endtime`, treatmentreasonzone.endtime);
    formData.append(`days`, treatmentreasonzone.days.toString());
    formData.append(`activedate`, treatmentreasonzone.activedate);
    formData.append(`u`,userId.toString());
    const url = `private/doctor/edittreatmentreasonzonesingle`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  createTreatmentreasonZone(accessToken: string, treatmentreasonzone,userId:number=0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "editTreatmentreasonZone request", treatmentreasonzone);
    }
    let formData = new FormData();
    formData.append(`reasonzonesToCreate`, treatmentreasonzone.reasonzonesToCreate.toString());
    formData.append(`starttime`, treatmentreasonzone.starttime);
    formData.append(`endtime`, treatmentreasonzone.endtime);
    formData.append(`days`, treatmentreasonzone.days.toString());
    formData.append(`activedate`, treatmentreasonzone.activedate);
    formData.append(`u`,userId.toString());
    const url = `private/doctor/createtreatmentreasonzone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editTreatmentreasonZone(accessToken: string, treatmentreasonzone): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "editTreatmentreasonZone request", treatmentreasonzone);
    }
    let formData = new FormData();
    formData.append(`reasonzonesToCreate`, treatmentreasonzone.reasonzonesToCreate.toString());
    formData.append(`zonesToEdit`, treatmentreasonzone.zonesToEdit.toString());
    formData.append(`zonesToDelete`, treatmentreasonzone.zonesToDelete.toString());
    formData.append(`starttime`, treatmentreasonzone.starttime);
    formData.append(`endtime`, treatmentreasonzone.endtime);
    formData.append(`days`, treatmentreasonzone.days.toString());
    formData.append(`activedate`, treatmentreasonzone.activedate);

    const url = `private/doctor/edittreatmentreasonzone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editNetworkAppointmentZone(accessToken: string, networkAppointmentZone): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, networkAppointmentZone.zoneId);
    formData.append(`doctor`, networkAppointmentZone.doctor);
    formData.append(`starttime`, networkAppointmentZone.starttime);
    formData.append(`endtime`, networkAppointmentZone.endtime);
    formData.append(`days`, networkAppointmentZone.days.toString());

    const url = `private/doctor/dashboard/editNetworkAppointmentZone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  editNetworkAppointmentZoneAssign(accessToken: string, networkAppointmentZoneAssign): Observable<any> {
    let formData = new FormData();
    formData.append(`id`, networkAppointmentZoneAssign.zoneAssignId);
    formData.append(`zone`, networkAppointmentZoneAssign.zone);
    formData.append(`networker`, networkAppointmentZoneAssign.networker);

    const url = `private/doctor/dashboard/editNetworkAppointmentZoneAssign`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveNetworkAppointmentZone(accessToken: string, networkAppointmentZone): Observable<any> {
    let formData = new FormData();
    formData.append(`doctor`, networkAppointmentZone.doctor);
    formData.append(`starttime`, networkAppointmentZone.starttime);
    formData.append(`endtime`, networkAppointmentZone.endtime);
    formData.append(`days`, networkAppointmentZone.days.toString());

    const url = `private/doctor/dashboard/saveNetworkAppointmentZone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveNetworkAppointmentZoneAssign(accessToken: string, networkAppointmentZoneAssign): Observable<any> {
    let formData = new FormData();
    formData.append(`zone`, networkAppointmentZoneAssign.zone);
    formData.append(`networker`, networkAppointmentZoneAssign.networker);

    const url = `private/doctor/dashboard/saveNetworkAppointmentZoneAssign`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveTreatmentreasonzone(accessToken: string, treatmentreasonzone): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveTreatmentreasonzone request", treatmentreasonzone);
    }
    let formData = new FormData();
    formData.append(`selectedreasons`, treatmentreasonzone.reasonIds.toString());
    formData.append(`starttime`, treatmentreasonzone.starttime);
    formData.append(`endtime`, treatmentreasonzone.endtime);
    formData.append(`days`, treatmentreasonzone.days.toString());
    formData.append(`activedate`, treatmentreasonzone.activedate);

    const url = `private/doctor/treatmentreasonzone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveTreatmentreason(accessToken: string, treatmentreason, userId:number=0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveTreatmentreason request", treatmentreason);
    }
    let formData = new FormData();
    formData.append(`name`, treatmentreason.name);
    formData.append(`docs`, treatmentreason.docs.toString());
    formData.append(`length`, treatmentreason.length);
    formData.append(`descr`, treatmentreason.descr);
    formData.append(`vss`, treatmentreason.isVss);
    formData.append(`color`, treatmentreason.color);
    formData.append(`leadTime`, treatmentreason.leadTime);
    formData.append(`maxTime`, treatmentreason.maxTime);
    formData.append(`dependency`, treatmentreason.dependency);
    formData.append(`isDependency`, treatmentreason.isDependency);
    formData.append(`isWaitingRoom`, treatmentreason.isWaitingRoom);
    formData.append(`maxBookings`, treatmentreason.maxBookings);

    formData.append(`shortTermisActive`, treatmentreason.shortTermisActive);
    formData.append(`shortTermStart`, treatmentreason.shortTermStart);
    formData.append(`stornoTime`, treatmentreason.stornoTime);
    /*formData.append(`shortTermEnd`,treatmentreason.shortTermEnd);
    formData.append(`shortTermLeadTime`,treatmentreason.shortTermLeadTime);
    formData.append(`shortTermMaxTime`,treatmentreason.shortTermMaxTime);*/
    formData.append(`u`,userId.toString());

    const url = `private/doctor/treatmentreason`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveTreatmentreasonWithZone(accessToken: string, treatmentreasonwithzone): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "savetreatmentreasonwithzone request", treatmentreasonwithzone);
    }
    let formData = new FormData();
    formData.append(`name`, treatmentreasonwithzone.name);
    formData.append(`docs`, treatmentreasonwithzone.doc);
    formData.append(`length`, treatmentreasonwithzone.length);
    formData.append(`descr`, treatmentreasonwithzone.descr);
    formData.append(`vss`, treatmentreasonwithzone.isVss);
    formData.append(`starttime`, treatmentreasonwithzone.starttime);
    formData.append(`endtime`, treatmentreasonwithzone.endtime);
    formData.append(`days`, treatmentreasonwithzone.days.toString());
    formData.append(`activedate`, treatmentreasonwithzone.activedate);

    const url = `private/doctor/treatmentreasonwithzone`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  loadNetworkAppointmentZonesAssign(accessToken) {
    const url = `private/doctor/dashboard/loadNetworkAppointmentZonesAssign`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  loadNetworkAppointmentZones(accessToken) {
    const url = `private/doctor/dashboard/loadNetworkAppointmentZones`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getTreatmentReasons(accessToken) {
    if (this.DEBUG) {
      console.log(this.TAG, "getTreatmentReasons");
    }
    const url = `private/doctor/gettreatmentreasons`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, "", {
        headers: headers,
      });
  }

  getTreatmentReasonsByDocId(accessToken, id) {
   // const body: string = [`id=${id}`].join("&");

    let formData = new FormData();
    formData.append(`id`, id);

    const url = `private/network/getTreatmentReasonsByDocId`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getReasonAdditionalsAPI(reasonId) {
    if (this.DEBUG) {
      console.log(this.TAG, "getReasonAdditionalsAPI");
    }
    //const body: string = [`reasonId=${reasonId}`].join("&");

    let formData = new FormData();
    formData.append(`reasonId`, reasonId);

    const url = `public/additionals/getAdditionalsByReason`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getWaitinglist(accessToken, doc) {
    //const body: string = [`doc=${doc}`].join("&");

    let formData = new FormData();
    formData.append(`doc`, doc);

    const url = `private/patient/getWaitinglist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getReasonAdditionals(accessToken, reasonID) {
    if (this.DEBUG) {
      console.log(this.TAG, "getReasonAdditionals");
    }
    //const body: string = [`reasonId=${reasonID}`].join("&");

    let formData = new FormData();
    formData.append(`reasonId`, reasonID);

    const url = `private/doctor/dashboard/additionals/getAdditionalsByReason`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveReasonAdditionals(accessToken, data) {
    if (this.DEBUG) {
      console.log(this.TAG, "saveReasonAdditionals", data);
    }
    let formData = new FormData();
    formData.append(`additionals`, JSON.stringify(data));
    const url = `private/doctor/dashboard/additionals/saveAdditionals`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  removeGroup(accessToken: string, id, userId:number = 0) {
    //const body: string = `id=${id}&u=${userId.toString()}`;

    let formData = new FormData();
    formData.append(`id`, id);
    formData.append(`u`, userId.toString());

    const url = `private/doctor/removeGroup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  removeTreatmentReasons(accessToken: string, reasonIds, userId:number=0) {
    if (this.DEBUG) {
      console.log(this.TAG, "removetreatmentreasons");
    }
   // const body: string = [`reasonId=${reasonIds}`,`u=${userId.toString()}`].join("&");

    let formData = new FormData();
    formData.append(`reasonId`, reasonIds);
    formData.append(`u`, userId.toString());


    const url = `private/doctor/removetreatmentreasons`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  removeTreatmentReasonZones(accessToken: string, zoneIds, userId:number = 0) {
    if (this.DEBUG) {
      console.log(this.TAG, "removeTreatmentReasonZones");
    }
   // const body: string = [`zoneids=${zoneIds}`,`u=${userId.toString()}`].join("&");

    let formData = new FormData();
    formData.append(`zoneids`, zoneIds);
    formData.append(`u`, userId.toString());

    const url = `private/doctor/removetreatmentreasonzones`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  changePW(accessToken: string, docId: number, oldPW: string, newPW: string): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "changePW request", docId);
    }
    /*
    const body: string = [
      `docId=${docId}`,
      `oldPW=${oldPW}`,
      `newPW=${newPW}`
    ].join("&");
*/
    let formData = new FormData();
    formData.append(`docId`, docId.toString());
    formData.append(`oldPW`, oldPW);
    formData.append(`newPW`, newPW);


    const url = `private/doctor/changepassword`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  saveDocProfile(accessToken: string, doc: Doctor, userId:number=0): Observable<any> {
    // sending multipart form data
    let formData = new FormData();
    // formData.append(`id`,doc.id.toString());
    formData.append(`id`, (doc.id > 0 || doc.id != null) ? doc.id.toString() : "");
    formData.append(`title`, doc.title);
    formData.append((doc.id > 0) ? `anr` : `gender`, doc.anr);
    formData.append((doc.id > 0) ? `name` : `first_name`, doc.name);
    formData.append((doc.id > 0) ? `surname` : `last_name`, doc.surname);
    formData.append((doc.id > 0) ? `address` : `street`, doc.address);
    formData.append(`zip`, doc.zip);
    formData.append(`city`, doc.city);
    formData.append(`mob`, doc.mob);
    formData.append(`web`, doc.web);
    formData.append(`tel`, doc.tel);
    if (doc.specialisations != undefined) {
      formData.append(`specs`, doc.specialisations.toString());
    }
    formData.append(`subemail`, doc.subemail);
    formData.append(`emails`, doc.emails.toString());
    formData.append(`favContact`, doc.favContact.toString());
    formData.append(`rememberSms`, doc.rememberSms.toString());
    formData.append(`waitinglist`, doc.waitinglist.toString());
    formData.append(`stornoTime`, doc.stornoTime.toString());
    /*formData.append(`autoRestoreStorno`,doc.autoRestoreStorno.toString());*/
    formData.append(`remindPatientMessage`, doc.remindPatientMessage.toString());
    formData.append(`u`,userId.toString());
    if (doc.newPic != null)
      formData.append("image", doc.newPic, doc.newPic.name);
    let url = "";
    if (doc.id > 0) url = `private/doctor/doctors/${doc.id}`;
    else url = `private/doctor/doctors`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    let queryUrl = `${environment.baseApiUrl}${url}`;
    // if (attachments != null) {
    //   attachments.forEach((file) => {
    //     formData.append("attachments[]", file.rawFile, file.name);
    //   });
    // }
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });


  }

  deleteDoc(accessToken: string, doc: number, userId:number = 0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", doc);
    }

    let body: string = `docId=${doc}&u=${userId.toString()}`;

    var url = `private/doctor/dashboard/subdocs/delete`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, body, {
        headers: headers,
      });
  }









  /*----------------------------FAVORITE DOCTORS----------------------------------------------------------------------*/

  getFavoriteDoctors(accessToken: string) {
    const url = `private/patient/getfavoritedoctors`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }


  deleteFavoriteDoctors(accessToken: string, id: number): Observable<any> {

    if(this.DEBUG)console.log(this.TAG, "delete Favorite Doctor request", id);

    let formData = new FormData();
    formData.append("id", id.toString());

    const url = `private/patient/deletefavoritedoctor`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }

  insertFavoriteDoctors(accessToken: string, doc): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", doc);
    }

    let formData = new FormData();
    formData.append("doctorid", doc);

    const url = `private/patient/savefavoritedoctor`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }


  //Todo medslist
  getMedList(accessToken: string) {
    const url = `private/patient/getmedlistpat`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  saveMedListPat(accessToken: string, data): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", data);
    }
    let formData = new FormData();
    formData.append("data", data);

    //join() every elements of an array to a string

    const url = `private/patient/savemedlistpat`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }



  activateMedListPat(accessToken: string, activ): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", activ);
    }

    let formData = new FormData();
    formData.append("activ", activ);
    //join() every elements of an array to a string

    const url = `private/patient/activatemedlistpat`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }


  deactivateMedListPat(accessToken: string): Observable<any> {
    let formData = new FormData();
    //join() every elements of an array to a string

    const url = `private/patient/deactivatemedlistpat`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }

  checkBMPList(accessToken: string, bmpid): Observable<any> {


    let formData = new FormData();
    formData.append("bmpid", bmpid);

    const url = `private/patient/checkbmplist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }

  setBMPList(accessToken: string, bmpid): Observable<any> {
    let formData = new FormData();
    formData.append("bmpid", bmpid);

    const url = `private/patient/setbmplist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }




  /*___________________________________PUBLIC HOLIDAY____________________________*/

  getHolidayList(accessToken: string, doc: number): Observable<any> {
    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getholidaylist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  getHolidayListbyDoc(accessToken: string, doc: number): Observable<any> {
    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getholidaylistbydoc`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }




  getHolidayListbyDocDate(id: number): Observable<any> {
    /* let body = [
      `id=${id}`
    ].join("&"); */

    let formData = new FormData();
    formData.append("id", id.toString());

    const url = `public/getholidaylistdocdate`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }



  deleteHolidayListbyDoc(accessToken: string, id: number): Observable<any> {

    if(this.DEBUG)console.log(this.TAG, "delete Holiday request", id);

    let body = [
      `id=${id}`
    ].join("&");

    const url = `private/doctor/dashboard/deleteholidaylistbydoc`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  insertHolidayListbyDoc(accessToken: string, doc, publicHolidaybyDoc, userId: number = 0 ): Observable<any> {
    let formData = new FormData();
    formData.append("doctorid", doc);
    formData.append("holidayid", publicHolidaybyDoc.join(','));
    formData.append("u", userId.toString());

    if (this.DEBUG) {
      console.log(this.TAG, "insertHolidayListbyDoc ApiHandler", publicHolidaybyDoc);
    }
    //join() every elements of an array to a string

    const url = `private/doctor/dashboard/insertholidaylistbydoc`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }


  saveInfoPopup(accessToken: string, doc, popup): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveInfoPopup", popup);
    }

    let body = [
      `doc=${doc}`,
      `popup=${popup}`
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/saveinfopopup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  getInfoPopup(accessToken: string, doc: number): Observable<any> {
    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getinfopopup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  getInfoPopupbyDoc(accessToken: string, doc: number, popupid: number): Observable<any> {

    let body = [
      `doc=${doc}`,
      `popupid=${popupid}`
    ].join("&");

    const url = `private/doctor/dashboard/getinfopopupbydoc`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  /*------------------ROLE-----------------*/

  getUsers(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getusers`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  setUser(accessToken: string, doc, username, pin, isAdmin): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", username, pin, isAdmin);
    }

    let body = [
      `doc=${doc}`,
      `username=${username}`,
      `isadmin=${isAdmin}`,
      `pin=${pin}`
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/setuser`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  deleteUser(accessToken: string, doc: number, userid): Observable<any> {

    let body = [
      `doc=${doc}`,
      `userid=${userid}`
    ].join("&");

    const url = `private/doctor/dashboard/deleteuser`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }



  getPermRoles(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getpermroles`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  getPermissionAction(accessToken: string, doc: number, role_id): Observable<any> {

    let body = [
      `doc=${doc}`,
      `role_id=${role_id}`
    ].join("&");

    const url = `private/doctor/dashboard/getpermissionaction`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }



  getPermAction(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getpermaction`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }



  getPermissionlist(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getpermissionlist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }



  getDocRole(accessToken: string, role_id: number): Observable<any> {

    let body = [
      `role_id=${role_id}`
    ].join("&");

    const url = `private/doctor/dashboard/getdocrole`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  getUserRole(accessToken: string, role_id: number): Observable<any> {

    let body = [
      `role_id=${role_id}`
    ].join("&");

    const url = `private/doctor/dashboard/getuserrole`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }





  getRoles(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getroles`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  setDocRole(accessToken: string, doc, docRights): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", docRights);
    }

    let body = [
      `doc=${doc}`,
      `konto=${docRights.konto}`,
      `kalender=${docRights.kalender}`,
      `behandlungsgruende=${docRights.behandlungsgruende}`,
      `netzwerk=${docRights.netzwerk}`,
      `statistiken=${docRights.statistiken}`,
      `plugins=${docRights.plugins}`,
      `upgrade=${docRights.upgrade}`,
      `type=${docRights.type}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/setdocrole`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  updateDocRole(accessToken: string, doc, docRights): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", docRights);
    }

    let body = [
      `doc=${doc}`,
      `role_id=${docRights.role_id}`,
      `konto=${docRights.konto}`,
      `kalender=${docRights.kalender}`,
      `behandlungsgruende=${docRights.behandlungsgruende}`,
      `netzwerk=${docRights.netzwerk}`,
      `statistiken=${docRights.statistiken}`,
      `plugins=${docRights.plugins}`,
      `upgrade=${docRights.upgrade}`,
      `type=${docRights.type}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/updatedocrole`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }
  

  
  
    // Use eid instead of accessToken
    getEmployees(): Observable<Employee[]> {
      const url = 'public/about';
      const queryUrl = `${environment.baseApiUrl}${url}`;
    
      return this.http.get<Employee[]>(queryUrl, {
        headers: new HttpHeaders().set('Accept', 'application/json')
      }).pipe(
        tap(response => {
          if (this.DEBUG) {
              console.log('Received employee data:', response);
          }
      })
      ,
        map((response: Array<any>) => response.map(item => new Employee(item))),
        catchError((error: HttpErrorResponse) => {
          console.error('Error fetching employees:', error.message);
          console.error('Status:', error.status);
          console.error('Status Text:', error.statusText);
          console.error('URL:', error.url);
          
          if (error.status === 404) {
            console.error('The endpoint was not found. Please check the URL or the server routing.');
          }
          
          return throwError(() => new Error('Failed to fetch employees'));
        })
      );
    }
  


    getOpenPositions(): Observable<newEmployee<{ designation: number; position: string }>[]> {
      const url = 'public/carrear';
      const queryUrl = `${environment.baseApiUrl}${url}`;
  
      return this.http.get<any[]>(queryUrl, {
        headers: new HttpHeaders().set('Accept', 'application/json')
      }).pipe(
        tap(response => {
          if (this.DEBUG) {
              console.log('Raw API Response:', response);
          }
      }),
        map((response: Array<any>) => {
          if(this.DEBUG) console.log('Data before mapping:', response);
  
          const mappedData = response.map(item => {
            return new newEmployee<{ designation: number; position: string }>({
              id: item.id || '',                  // Ensure 'id' is correctly mapped
              designation: item.designation || 0, // Ensure 'designation' is correctly mapped
              position: item.position || '',      // Ensure 'position' is correctly mapped
              job: item.job || '',                // Include 'job' property
              profile: item.profile || '',        // Include 'profile' property
              tasks: item.tasks || '',            // Include 'tasks' property
              benefits: item.benefits || '', 
              description: item.description || '',// Include 'description' property
              data: {                             // Provide the 'data' object with required structure
                designation: item.designation,
                position: item.position
              }
            });
          });
  
          if(this.DEBUG) console.log('Mapped Data:', mappedData);
          return mappedData;
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('Error fetching employees:', error.message);
          console.error('Status:', error.status);
          console.error('Status Text:', error.statusText);
          console.error('URL:', error.url);
  
          return throwError(() => new Error('Failed to fetch employees'));
        })
      );
    }
  
  
    
    
    getNews(): Observable<News[]> {
      const url = 'public/news';
      const queryUrl = `${environment.baseApiUrl}${url}`;
  
      return this.http.get<News[]>(queryUrl, {
        headers: new HttpHeaders().set('Accept', 'application/json')
      }).pipe(
        tap(response => {
          if (this.DEBUG) {
              console.log('Received news data:', response);
          }
      })
      ,
        map((response: any[]) => response.map(item => new News(item))),
        catchError((error: HttpErrorResponse) => {
          console.error('Error fetching news:', error.message);
          console.error('Status:', error.status);
          console.error('Status Text:', error.statusText);
          console.error('URL:', error.url);
  
          if (error.status === 404) {
            console.error('The endpoint was not found. Please check the URL or the server routing.');
          }
  
          return throwError(() => new Error('Failed to fetch news'));
        })
      );
    }
  
    
    
    
    
    
  


  setRole(accessToken: string, userid, role_id): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveRole request", role_id);
    }

    let body = [
      `userid=${userid}`,
      `role_id=${role_id}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/setrole`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  checkPIN(accessToken: string, username, pin): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveRole request", pin);
    }

    let body = [
      `username=${username}`,
      `pin=${pin}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/checkpin`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }



  setPIN(accessToken: string, userid, pin): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveRole request", pin);
    }

    let body = [
      `userid=${userid}`,
      `pin=${pin}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/setpin`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  isPIN(accessToken: string, doc): Observable<any> {

    let body = [
      `doc=${doc}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/ispin`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }


  /*--------------------------URLAUB-------------------------*/
 /*  getPracticeUrlaub(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getpracticeurlaub`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  } */

  getDocUrlaubbyDocId(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/geturlaubbydocid`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  getUrlaub(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/geturlaub`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  getUrlaubByDocId(id: number): Observable<any> {
   /*  let body = [
      `id=${id}`
    ].join("&"); */

    let formData = new FormData();
    formData.append("id", id.toString());

    const url = `public/urlaubsingle`;
    const headers = new HttpHeaders().append("Accept","1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
      headers: headers,
    });
  }


  getPracticeurlaub(id: number): Observable<any> {
    let formData = new FormData();
    formData.append("id", id.toString());

    const url = `public/practiceurlaub`;
    const headers = new HttpHeaders();
    headers.append("Accept", "1.0");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, formData, {
        headers: headers,
    }).pipe( map((response: Response) => {
      return response;
    }));
    
  }


  deleteUrlaub(accessToken: string, id: number, userId:number = 0): Observable<any> {

    if(this.DEBUG)console.log(this.TAG, "delete Urlaub request", id);

    let body = [
      `id=${id}`,
      `u=${userId.toString()}`
    ].join("&");

    const url = `private/doctor/dashboard/deleteurlaub`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  insertUrlaub(accessToken: string, doc, urlaubTimes, userId:number = 0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", urlaubTimes);
    }

    let body = [
      `doc=${doc}`,
      `anfangdate=${urlaubTimes.startdate}`,
      `anfangtime=${urlaubTimes.starttime}`,
      `endedate=${urlaubTimes.enddate}`,
      `endetime=${urlaubTimes.endtime}`,
      `isPractice=${urlaubTimes.isPractice}`,
      `u=${userId.toString()}`,
    ].join("&");
    //join() every elements of an array to a string
    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/saveurlaub`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  deleteApps(accessToken: string, doc: number, start, end, days, userId:number=0): Observable<any> {
    let body = [
      `doc=${doc}`,
      `start=${start}`,
      `end=${end}`,
      `days=${days}`,
      `u=${userId.toString()}`,
    ].join("&");

    const url = `private/doctor/dashboard/deleteapps`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  /*-----------------------ENDE URLAUB -------------------------------*/

  getWorktime(accessToken: string, doc: number): Observable<any> {

    let body = [
      `doc=${doc}`
    ].join("&");

    const url = `private/doctor/dashboard/getworktime`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  saveWorktime(accessToken: string, doc: number, openingTimes, userId:number = 0): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "saveDoc request", openingTimes);
    }

    let body = [
      `doc=${doc.toString()}`,
      `moopening=${openingTimes.montag.opening}`,
      `moclosing=${openingTimes.montag.closing}`,
      `mobreakstart=${openingTimes.montag.breakStart}`,
      `mobreakend=${openingTimes.montag.breakEnd}`,
      `diopening=${openingTimes.dienstag.opening}`,
      `diclosing=${openingTimes.dienstag.closing}`,
      `dibreakstart=${openingTimes.dienstag.breakStart}`,
      `dibreakend=${openingTimes.dienstag.breakEnd}`,
      `miopening=${openingTimes.mittwoch.opening}`,
      `miclosing=${openingTimes.mittwoch.closing}`,
      `mibreakstart=${openingTimes.mittwoch.breakStart}`,
      `mibreakend=${openingTimes.mittwoch.breakEnd}`,
      `doopening=${openingTimes.donnerstag.opening}`,
      `doclosing=${openingTimes.donnerstag.closing}`,
      `dobreakstart=${openingTimes.donnerstag.breakStart}`,
      `dobreakend=${openingTimes.donnerstag.breakEnd}`,
      `fropening=${openingTimes.freitag.opening}`,
      `frclosing=${openingTimes.freitag.closing}`,
      `frbreakstart=${openingTimes.freitag.breakStart}`,
      `frbreakend=${openingTimes.freitag.breakEnd}`,
      `saopening=${openingTimes.samstag.opening}`,
      `saclosing=${openingTimes.samstag.closing}`,
      `sabreakstart=${openingTimes.samstag.breakStart}`,
      `sabreakend=${openingTimes.samstag.breakEnd}`,
      `soopening=${openingTimes.sonntag.opening}`,
      `soclosing=${openingTimes.sonntag.closing}`,
      `sobreakstart=${openingTimes.sonntag.breakStart}`,
      `sobreakend=${openingTimes.sonntag.breakEnd}`,
      `u=${userId.toString()}`
    ].join("&");

    if(this.DEBUG)console.log('body', body);

    const url = `private/doctor/dashboard/saveworktime`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  getIdOfDocAppByTime(accessToken: string, doctor, start, end): Observable<any> {
    let body = [
      `doctor=${doctor}`,
      `start=${start}`,
      `end=${end}`,
    ].join("&");

    const url = `private/doctor/dashboard/getidofdocappbytime`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http.post(queryUrl, body, {
      headers: headers,
    });
  }

  addSingleAppointment(accessToken: string, calId: number, start: string, end: string, insurance: number[], reason: number, userId:number = 0) {
    if (this.DEBUG) {
      console.log(this.TAG, "add Appointment request", calId, start, end, insurance);
    }

    let body = [
      `calId=${calId}`,
      `start=${start}`,
      `end=${end}`,
      `insurance=${insurance.join("&insurance=")}`,
      `reason=${reason.toString()}`,
      `u=${userId.toString()}`
    ].join("&");


    var url = `private/doctor/dashboard/addEvent`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, body, {
        headers: headers,
      });
  }

  addMultipleAppointment(accessToken: any, calId: number, sd: string, ed: string, st: string, et: string, step: number, insurance: number[], excludes: number[], weekStep: number, reason: number, userId:number = 0) {
    if (this.DEBUG) {
      console.log(this.TAG, "add Appointment request", calId, sd, ed, st, et, step, excludes, insurance);
    }

    let body = [
      `calId=${calId}`,
      `startDate=${sd}`,
      `endDate=${ed}`,
      `startZone=${st}`,
      `endZone=${et}`,
      `eventDuration=${step}`,
      `excludes=${excludes.toString()}`,
      `insurance=${insurance.toString()}`,
      `weekStep=${weekStep == undefined ? '-1' : weekStep.toString()}`,
      `reason=${reason.toString()}`,
      `u=${userId.toString()}`
    ].join("&");

    var url = `private/doctor/dashboard/addMultipleEvents`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, body, {
        headers: headers,
      });
  }

  cancelAppointment(accessToken: any, id: string, userId:number = 0) {
    if (this.DEBUG) {
      console.log(this.TAG, "cancel Appointment request", id);
    }

    let body = [
      `appuid=${id}`,
      `u=${userId}`,
    ].join("&");


    var url = `private/doctor/dashboard/cancelEvent`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, body, {
        headers: headers,
      });
  }

  deleteAppointment(accessToken: any, id: string) {
    if (this.DEBUG) {
      console.log(this.TAG, "delete Appointment request", id);
    }

    let body = [
      `appuid=${id}`,
    ].join("&");


    var url = `private/doctor/dashboard/delEvent`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, body, {
        headers: headers,
      });
  }

  getForm(formName: string): Observable<any> {
    /*const body: string = [
      `formName=${formName}`
    ].join("&");*/
    let formData = new FormData();
    formData.append("formName", formName);
    const url = `public/getForm`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  getViomediToken(accessToken: any): Observable<any> {
    const url = `private/doctor/getViomediToken`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, "", {
        headers: headers
      });
  }

  getViomediSubs(accessToken: any): Observable<any> {
    const url = `private/doctor/getViomediSubs`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, "", {
        headers: headers
      });
  }

  getTermedViomediSubs(accessToken: any): Observable<any> {
    const url = `private/doctor/getTermedViomediSubs`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, "", {
        headers: headers
      });
  }

  saveViomediSub(accessToken: any, doctorId, vioId): Observable<any> {
    /*const body: string = [
      `doctorId=${doctorId}`,
      `vioId=${vioId}`
    ].join("&");*/
    let formData = new FormData();
    formData.append("doctorId", doctorId);
    formData.append("vioId", vioId);
    const url = `private/doctor/saveViomediSub`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  getWaitingRoomAPI(doctorId: string): Observable<any> {
    /*const body: string = [
      `doctorId=${doctorId}`
    ].join("&");*/
    let formData = new FormData();
    formData.append("doctorId", doctorId);
    let url = `public/getWaitingRoomStatus`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  getWaitingRoomDoc(accessToken): Observable<any> {
    const url = "private/doctor/getWaitingRooms";
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, "", {
        headers: headers
      });
  }

  openCloseWaitingRoom(accessToken: string, docName: string, roomToken: string, type): Observable<any> {
    /*const body: string = [
      `roomToken=${roomToken}`,
      `docName=${docName}`,
      `type=${type}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("roomToken", roomToken);
    formData.append("docName", docName);
    formData.append("type", type);

    const url = `private/doctor/openCloseWaitingRoom`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  bookWaitingRoom(accessToken: string, roomToken, docId) {

    let formData = new FormData();
    formData.append("roomToken", roomToken);
    formData.append("docId", docId);

    const url = `private/patient/bookWaitingRoom`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  joinWaitingRoom(accessToken: string, roomToken, eventId, docId,
    symptoms: string,
    insKKNumber: string,
    insName: string,
    insNumber: string,
    insStatus: string,
    egkF: File,
    egkB: File,
    attachments) {
    let formData = new FormData();
    formData.append("roomToken", roomToken);
    formData.append("eventId", eventId);
    formData.append("docId", docId);
    formData.append("symptoms", symptoms);
    formData.append("insKKNumber", insKKNumber);
    formData.append("insName", insName);
    formData.append("insNumber", insNumber);
    formData.append("insStatus", insStatus);
    if (egkF != null) {
      formData.append("egkf", egkF, egkF.name);
    }
    if (egkB != null) {
      formData.append("egkb", egkB, egkB.name);
    }
    if (attachments != null) {
      attachments.forEach((file) => {
        formData.append("attachments[]", file.rawFile, file.name);
      });
    }

    const url = `private/patient/joinWaitingRoom`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    if(this.DEBUG)console.log("formdata", formData, queryUrl);
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  checkBlacklist(accessToken: string, docID): Observable<any> {
    /*const body: string = [
      `doctor=${docID}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("doctor", docID);

    const url = `private/patient/checkBlacklist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  addToBlacklist(accessToken: string, email: string, docID): Observable<any> {
    /*const body: string = [
      `doctor=${docID}`,
      `email=${email}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("doctor", docID);
    formData.append("email", email);

    const url = `private/doctor/blacklist/addToBlacklist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  getAllBlacklist(accessToken: string): Observable<any> {


    const url = `private/doctor/blacklist/getAllBlacklist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, "", {
        headers: headers
      });
  }

  removeFromBlacklist(accessToken: string, id): Observable<any> {
    /*const body: string = [
      `id=${id}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("id", id);

    const url = `private/doctor/blacklist/removeFromBlacklist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  updateBlacklist(accessToken: string, id, email: string, active: string, docID): Observable<any> {
    /*const body: string = [
      `doctor=${docID}`,
      `id=${id}`,
      `active=${active}`,
      `email=${email}`
    ].join("&");*/

    let formData = new FormData();
    formData.append("doctor", docID);
    formData.append("id", id);
    formData.append("active", active);
    formData.append("email", email);

    const url = `private/doctor/blacklist/updateBlacklist`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  saveLockedText(accessToken: string, lockedText): Observable<any> {
    let formData = new FormData();
    formData.append(`lockedText`, lockedText);

    const url = `private/doctor/blacklist/saveLockedText`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  sendContactForm(data): Observable<any> {
    let formData = new FormData();
    console.log("Formulardaten mit Datei für den Upload:", data);

    if (data.upload != undefined && data.upload.length > 0) {
        data.upload.forEach(file => {
            formData.append('uploads[]', file, file.name);
            console.log("Hochgeladene Datei:", file);
        });
    }

    data.upload = '';
    formData.append(`contactFormData`, JSON.stringify(data));

    // Use forEach to log each entry in FormData
    formData.forEach((value, key) => {
        console.log("FormData Inhalt:", key, value);
    });

    const url = `public/contactweb`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}`;

    console.log("Daten und Ziel-URL für den finalen API-Aufruf:", queryUrl, formData);
    return this.http.post(queryUrl, formData, { headers: headers });
}

  sendPartnerForm(formData): Observable<any> {
      const form = new FormData();
      Object.keys(formData).forEach(key => form.append(key, formData[key]));

      const url = 'public/contactSales';
      const baseUrl = environment.baseApiUrl.endsWith('/') ? environment.baseApiUrl : `${environment.baseApiUrl}/`;
      return this.http.post(`${baseUrl}${url}`, form);
  }


  checkStornoToken(token: String): Observable<any> {
    const url = `public/checkStornoToken/`;
    const queryUrl = `${environment.baseApiUrl}${url}${token}`;

    return this.http
      .get(queryUrl);
  }

  stornoApp(uid: String): Observable<any> {
    const url = `public/stornoApp/`;
    const queryUrl = `${environment.baseApiUrl}${url}${uid}`;
    const headers = new HttpHeaders().append("Accept","1.0");
    //headers.set("Accept", "1.0");

    return this.http
      .post(queryUrl, "", {
        headers: headers
      });
  }

  setUserMainCalendarAPI(accessToken: String, user, calId) {
    const url = `private/doctor/dashboard/setUserMainCalendar`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    let formData = new FormData();
    formData.append(`u`, user.toString());
    formData.append(`c`, calId.toString());

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers
      });
  }

  getLoggingData(accessToken: string, tableName, changeType, changeDateFrom, changeDateTo, user, limitFrom): Observable<any> {
    let formData = new FormData();
    formData.append(`tableName`,tableName.join(","));
    formData.append(`changeType`,changeType.join(","));
    formData.append(`changeDateFrom`,changeDateFrom.toString());
    formData.append(`changeDateTo`,changeDateTo.toString());
    formData.append(`user`,user.join(","));
    formData.append(`limitFrom`,limitFrom.toString())

    const url = `private/doctor/getLoggingData`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
    .post(queryUrl, formData, {
      headers: headers,
    })
    ;
  }

  
  

  makeNoteEvent(accessToken: any, doctor, note, start, end) {
    if (this.DEBUG) {
      console.log(this.TAG, "quit Account in ApiHandler");
    }
    let formData = new FormData();

    formData.append("doctor", doctor);
    formData.append("note", note);
    formData.append("start", start);
    formData.append("end", end);

    const url = `private/doctor/makenoteevent`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
      
  }


  deleteNote(accessToken: any, noteid) {
    if (this.DEBUG) {
      console.log(this.TAG, "quit Account in ApiHandler");
    }
    let formData = new FormData();

    formData.append("noteid", noteid);

    const url = `private/doctor/deletenote`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
      
  }


  getPluginSettings(
    docid: string,
  ): Observable<any> {
    let formData = new FormData();
    formData.append("docid", docid);

    const url = `public/patient/pluginsettings`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  
  getCategorySpecs(): Observable<any> {
    let formData = new FormData();
   
    const url = `public/patient/getcategoryspecs`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  cancelGroupEvent(
    accessToken: string,
    eventId: string,
    symptoms: string
  ): Observable<any> {
    if (this.DEBUG) {
      console.log(this.TAG, "cancelEvent request", eventId, symptoms);
    }
    //const body: string = [`symptoms=${symptoms}`].join("&");
    let formData = new FormData();
    formData.append("symptoms", symptoms);

    const url = `private/patient/cancelGroup`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}/${eventId}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  disableBMP(
    accessToken: string,
    uid: string
  ): Observable<any> {
    let formData = new FormData();
    formData.append("uid", uid);

    const url = `private/patient/bmp/disable`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  deleteBMP(
    accessToken: string,
    uid: string
  ): Observable<any> {
    let formData = new FormData();
    formData.append("uid", uid);

    const url = `private/patient/bmp/delete`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  activateBMP(
    accessToken: string,
    uid: string
  ): Observable<any> {
    let formData = new FormData();
    formData.append("uid", uid);

    const url = `private/patient/bmp/activate`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  shareActiveBMP(
    accessToken: string,
  ): Observable<any> {
    const url = `private/patient/bmp/share`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }
  checkReasonCode(reason,code:string): Observable<any> {
    let formData = new FormData();
    formData.append("reason",reason.toString());
    formData.append("code",code);
    
    const url = `public/checkReasonCode`;
    const headers = new HttpHeaders().append("Accept","1.0");

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getDoctorFormByUId(formId) {
    if (this.DEBUG) {
      console.log(this.TAG, "getDoctorForms");
    }

    const url = `public/formular/getFormular`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  sendDocForm(accessToken, formularData, docId){
    let formId = formularData.uid;
    let formData = new FormData();
    formData.append('sendDoctor',docId);
    formData.append('doctor',formularData.doctor);
    formData.append('name',formularData.name);
    formData.append('logo',formularData.logo);
    formData.append('sType',formularData.sType);
    formData.append('docSign',formularData.docSign);
    formData.append('multiSign',formularData.multiSign);
    formData.append('sendEmail',formularData.sendEmail);
    formData.append('directMSign',formularData.directMSign ? "1" : "0");
    formData.append('signThirds',formularData.signThirds ? "1" : "0");
    formData.append('thieme',formularData.thieme ? "1" : "0");
    formData.append('signatureData',formularData.signatureData);
    formData.append('signature2Data',formularData.signature2Data);
    formData.append('signature2Name',formularData.signature2Name);
    formData.append('signature2Email',formularData.signature2Email);
    formData.append('signature3Data',formularData.signature3Data);
    formData.append('signature3Name',formularData.signature3Name);
    formData.append('signature3Email',formularData.signature3Email);
    formData.append('sections',JSON.stringify(formularData.sections));
    formData.append('logicData',JSON.stringify(formularData.logicData));

    let url = `public/formular/sendFormular`;
    let headers = new HttpHeaders().append("Accept","1.0");

    if(accessToken !== ""){
      url = `private/patient/formular/sendFormular`;
      headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);;
    }
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  checkFormular(id) {
    if (this.DEBUG) {
      console.log(this.TAG, "getDoctorForms");
    }

    const url = `public/formular/getReasonFormular`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}/${id}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  finishSendDocForm(accessToken, formId, srId, type){
    let formData = new FormData();
    formData.append('srId',srId);

    let typeEp = "success";
    if(type !== "success"){
      typeEp = "cancel";
    }
    let url = `public/formular/sendFormular`;
    let headers = new HttpHeaders().append("Accept","1.0");

    if(accessToken !== ""){
      url = `private/patient/formular/sendFormular`;
      headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);;
    }
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}/${typeEp}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  checkDoctorForm(formId, docId){
    if (this.DEBUG) {
      console.log(this.TAG, "getDoctorForms");
    }

    const url = `public/formular/checkDoctorFormular`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}/${docId}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getExternalDocInfo(id): Observable<any>{
    if (this.DEBUG) {
      console.log(this.TAG, "getDoctorForms");
    }

    const url = `public/doctor/getExternalData`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}/${id}`;

    return this.http
    .get(queryUrl, {
      headers: headers,
    });
  }

  getAllChainsOfDoctor(docId){
    let formData = new FormData();
    formData.append('docId',docId);

    let url = `public/chains/getallchainsofdoctor`;
    let headers = new HttpHeaders().append("Accept","1.0");
    
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  getChainDetail(chainId){
    let formData = new FormData();
    formData.append('chainId',chainId);

    let url = `public/chains/getchaindetail`;
    let headers = new HttpHeaders().append("Accept","1.0");
    
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  checkPatientDataComplete(email: string, accessToken: string): Observable<boolean> {
    const url = `public/patient/checkdata/${email}`;
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    });
    const queryUrl = `${environment.baseApiUrl}${url}`;
  
    return this.http.get<boolean>(queryUrl, { headers }).pipe(
      tap(response => console.log('API-Antwort:', response))
    );
  }

    updatePatient(
    payload: {
      address: string | null,
      housenr: string | null,
      zip: string | null,
      city: string | null,
      
    },
    accessToken: string
  ): Observable<any> {
    const formData = new FormData();
  
    const optionalFields: (keyof typeof payload)[] = ['address', 'housenr', 'zip', 'city'];
    optionalFields.forEach((key) => {
      const value = payload[key];
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });
  
    // Logging the FormData
    if (this.DEBUG) console.log('Daten an Backend (ohne doctor_id):');
    formData.forEach((value, key) => {
      if (this.DEBUG) console.log(`${key}: ${value}`);
    });
  
    const url = `private/patient/updatePatient`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', `Bearer ${accessToken}`);
  
    const postUrl = `${environment.baseApiUrl}${url}`;
  
    return this.http.post(postUrl, formData, { headers });
  }

    checkPatientFieldsByDoctorId(docId: number, accessToken: string) {
    const url = `private/patient/checkpatientfields/${docId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', `Bearer ${accessToken}`);
  
    const queryUrl = `${environment.baseApiUrl}${url}`;
  
    return this.http.get(queryUrl, { headers });
  }

  getTrainings(){
    let url = `public/training/getAllTrainings`;
    let headers = new HttpHeaders().append("Accept","1.0");
    
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  registerTraining(data){
    const formData = new FormData();
    formData.append("tId",data.tId);
    formData.append("tName",data.tName);
    formData.append("name",data.name);
    formData.append("email",data.email);
    formData.append("company",data.company);
    formData.append("bookedData",JSON.stringify(data.bookedData));

    let url = `public/training/register`;
    let headers = new HttpHeaders().append("Accept","1.0");
    
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      });
  }

  searchDoctorsNew(
  search: string = '',
  specID: number,
  lat: number = 0,
  long: number = 0,
  limit: number = 20,
  offset: number = 0
): Observable<any> {
  const url = `${environment.baseApiUrl}public/doctorSearch`;

  const body = {
    search,
    specID: specID.toString(),
    lat,
    long,
    limit,
    offset
  };

  return this.http.post(url, body).pipe(
    map((response: any) => response.results || []),
    catchError((error) => {
      console.error('Doctor Search Error', error);
      return of([]);
    })
  );
}

getPatientDashboardData(accessToken: string) {
  let url = `private/patient/getPatientHistory`;
  const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
  let queryUrl = `${environment.baseApiUrl}${url}`;
  return this.http
    .get(queryUrl, {
      headers: headers,
    });
}

  getFaqs() { 
    const headers = new HttpHeaders().append("Accept","1.0");
    const url = `public/faqs`;
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .get(queryUrl,{
        headers: headers,
      });
  }

  getPatinetFavDocRequest(accessToken: string) {
    let url = `private/patient/getPatientHistory`;
    const headers = new HttpHeaders().append("Accept","1.0").append("Authorization", `Bearer ${accessToken}`);
    let queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  doctorDetail(id: string, lat, lon): Observable<DoctorDetail>{
    let url = `public/doctorDetail`;
    let headers = new HttpHeaders().append("Accept","1.0");
    
    const queryUrl = `${environment.baseApiUrl}${url}/${id}/${lat}/${lon}`;
    /*return this.http
      .get(queryUrl, {
        headers: headers,
      });*/

    return this.http.get(queryUrl).pipe(
      map((responseData: Response) => {
        return new DoctorDetail(responseData);
      }),
    );
  }

  getPatientEventById(accessToken, id){
    const formData = new FormData();
    formData.append("eventId",id);

    const url = `private/patient/getPatientEventById`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', `Bearer ${accessToken}`);
      
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http
      .post(queryUrl, formData, {
        headers: headers,
      }).pipe(
      map((responseData: Response) => {
        return new PatientEvent(responseData);
      }),
    );
  }

  checkDoctorFormularVersion(formId, docId){
    if (this.DEBUG) {
      console.log(this.TAG, "checkDoctorFormularVersion");
    }

    const url = `public/formular/checkDoctorFormularVersion`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}/${docId}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }

  getDoctorNewFormByUId(formId) {
    if (this.DEBUG) {
      console.log(this.TAG, "getDoctorForms");
    }

    const url = `public/formular/getNewFormular`;
    const headers = new HttpHeaders().append("Accept", "1.0");
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}`;

    return this.http
      .get(queryUrl, {
        headers: headers,
      });
  }


  saveFormPatientDraft(accessToken: any, payload: any) {
    let formData = new FormData();
    formData.append("form_uid", payload.form_uid);
    formData.append("content", payload.content);
    formData.append("status", payload.status);

    const url = `private/patient/formular/savePatientFormDraft`;
    const headers = new HttpHeaders().append("Accept", "1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http.post(queryUrl, formData, {
        headers: headers,
    });    
  }

  getPatientFormDraft(accessToken: any, formId: any) {
    const url = `private/patient/formular/getPatientFormDraft`;
    const headers = new HttpHeaders().append("Accept", "1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}`;
    return this.http.get(queryUrl, {
      headers: headers,
    });
  }

  sendNewFormPatient(accessToken: any, payload: any, docId: any) {
    let formData = new FormData();
    formData.append("form_uid", payload.form_uid);
    formData.append("content", payload.content);
    formData.append("status", payload.status);
    formData.append("docId", docId);
    formData.append("submitted_at", payload.submittedAt);

    let url = `public/formular/newFormPatient`;
    let headers = new HttpHeaders().append("Accept", "1.0");

    if (accessToken && accessToken !== "") {
      url = `private/patient/formular/newFormPatient`; 
      headers = headers.append("Authorization", `Bearer ${accessToken}`);
    }

    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http.post(queryUrl, formData, {
        headers: headers,
    });    
  }

  sendFormPdfViaEmail(payload ){
    const formData = new FormData();
    formData.append("firstname",payload.firstname);
    formData.append("lastname",payload.lastname);
    formData.append("email",payload.email);
    formData.append("pdf_url",payload.pdf_url);
    formData.append("form_uid",payload.form_uid);
    formData.append("form_name",payload.form_name);

    let url = `public/formular/sendFormPdfViaEmail`;
    let headers = new HttpHeaders().append("Accept","1.0");
    
    const queryUrl = `${environment.baseApiUrl}${url}`;
    return this.http.post(queryUrl, formData, {
        headers: headers,
      });
  }

  postTenYearsRegistration(data: any) {
      const formData = new FormData();

      formData.append('firstName', data.firstName);
      formData.append('lastName', data.lastName);
      formData.append('company', data.company || '');
      formData.append('email', data.email);
      formData.append('participants', String(data.participants));
      formData.append('hotel', data.hotel === true ? '1' : '0');
      formData.append('karting', data.karting === true ? '1' : '0');
      formData.append('privacyAccepted', String(data.privacyAccepted ? 1 : 0));
      formData.append('dataCorrect', String(data.dataCorrect ? 1 : 0));
      formData.append('companionFirstName',data.companionFirstName || '');
      formData.append('companionLastName',data.companionLastName || '');


      const url = `${environment.baseApiUrl}public/tenYearsRegistration`;


      const headers = new HttpHeaders().append('Accept', '1.0');

      return this.http.post(url, formData, { headers });
    }

    checkPartyRegestration(email: string): Observable<{ exists: boolean }> {
    const url = `${environment.baseApiUrl}public/checkPartyRegistration`;

    
    const headers = new HttpHeaders().append('Accept', 'application/json');

    return this.http.post<{ exists: boolean }>(url, { email }, { headers });
  }

  deletePatientFormDraft(accessToken: any, formId: any) {
    const url = `private/patient/formular/deletePatientFormDraft`;
    const headers = new HttpHeaders().append("Accept", "1.0").append("Authorization", `Bearer ${accessToken}`);
    const queryUrl = `${environment.baseApiUrl}${url}/${formId}`;
    return this.http.get(queryUrl, {
      headers: headers,
    });
  }

}
function intervall(arg0: number) {
  throw new Error('Function not implemented.');
}

